var pricingData = [
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-UpFront",
        "price": 1743.14,
        "softPrice": 2.39,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-UpFront",
        "price": 1707.51,
        "softPrice": 2.34,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-UpFront",
        "price": 839.69,
        "softPrice": 1.15,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412FU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-PartUpFront",
        "price": 1074.13,
        "softPrice": 1.47,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436PU"
    },
    {
        "name": "HANA-32vCPU-256GB-3Yrs-UpFront",
        "price": 3679,
        "softPrice": 5.04,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125636FU"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-NoUpFront",
        "price": 2418.95,
        "softPrice": 3.31,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636MO"
    },
    {
        "name": "Oracle-32vCPU-128GB-3Yrs-NoUpFront",
        "price": 6177.46,
        "softPrice": 8.46,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112836MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-UpFront",
        "price": 1939,
        "softPrice": 2.66,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036FU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-NoUpFront",
        "price": 1671.7,
        "softPrice": 2.29,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612MO"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-UpFront",
        "price": 70.08,
        "softPrice": 0.1,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212FU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-UpFront",
        "price": 1674.07,
        "softPrice": 2.29,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-NoUpFront",
        "price": 3973.99,
        "softPrice": 5.44,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-PartUpFront",
        "price": 1977.39,
        "softPrice": 2.71,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-NoUpFront",
        "price": 1878.12,
        "softPrice": 2.57,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-NoUpFront",
        "price": 1654.19,
        "softPrice": 2.27,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-UpFront",
        "price": 1283.64,
        "softPrice": 1.76,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812FU"
    },
    {
        "name": "HANA-12vCPU-96GB-3Yrs-UpFront",
        "price": 1479,
        "softPrice": 2.03,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109636FU"
    },
    {
        "name": "Oracle-12vCPU-96GB-On-Demand",
        "price": 3802.37,
        "softPrice": 3802.37,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109600MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-On-Demand",
        "price": 1878.96,
        "softPrice": 1878.96,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102400MO"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-On-Demand",
        "price": 1344.29,
        "softPrice": 1344.29,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201600MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 1709.41,
        "softPrice": 2.34,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812PU"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-NoUpFront",
        "price": 2153.92,
        "softPrice": 2.95,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412MO"
    },
    {
        "name": "Oracle-12vCPU-48GB-1Yr-UpFront",
        "price": 2737.52,
        "softPrice": 3.75,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104812FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-PartUpFront",
        "price": 2480.4,
        "softPrice": 3.4,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612PU"
    },
    {
        "name": "Oracle-4vCPU-32GB-1Yr-UpFront",
        "price": 1161.74,
        "softPrice": 1.59,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103212FU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 769.3,
        "softPrice": 1.05,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212PU"
    },
    {
        "name": "FWaaS-FortiNet-Enterprise-Small",
        "price": 74.67,
        "softPrice": 1037.86,
        "SKU": "CLLICFORFWE00S12MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-NoUpFront",
        "price": 1526.92,
        "softPrice": 2.09,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-PartUpFront",
        "price": 1417.57,
        "softPrice": 1.94,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012PU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-NoUpFront",
        "price": 1914.6,
        "softPrice": 2.62,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3Yrs-UpFront",
        "price": 3393.25,
        "softPrice": 4.65,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 215.02,
        "softPrice": 0.29,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812PU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-PartUpFront",
        "price": 1832.87,
        "softPrice": 2.51,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636PU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-NoUpFront",
        "price": 1416.52,
        "softPrice": 1.94,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612MO"
    },
    {
        "name": "HANA-40vCPU-160GB-On-Demand",
        "price": 7785.8,
        "softPrice": 7785.8,
        "vcpu": "40",
        "ram": "160",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116000MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-UpFront",
        "price": 1085.12,
        "softPrice": 1.49,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-UpFront",
        "price": 3766.65,
        "softPrice": 5.16,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412FU"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 2504.53,
        "softPrice": 3.43,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-NoUpFront",
        "price": 142.15,
        "softPrice": 0.19,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-On-Demand",
        "price": 4682.05,
        "softPrice": 4682.05,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110400MO"
    },
    {
        "name": "Oracle-32vCPU-256GB-3Yrs-NoUpFront",
        "price": 6828.08,
        "softPrice": 9.35,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125636MO"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 2057.47,
        "softPrice": 2.82,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436PU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-PartUpFront",
        "price": 1157.33,
        "softPrice": 1.59,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636PU"
    },
    {
        "name": "Managed-MS-Exchange",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCSMS0EXC00000MO"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-UpFront",
        "price": 2789.02,
        "softPrice": 3.82,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-UpFront",
        "price": 138.41,
        "softPrice": 0.19,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412FU"
    },
    {
        "name": "Oracle-6vCPU-48GB-3Yrs-UpFront",
        "price": 1281.99,
        "softPrice": 1.76,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104836FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 222.71,
        "softPrice": 0.31,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836PU"
    },
    {
        "name": "HANA-18vCPU-144GB-1Yr-PartUpFront",
        "price": 3366,
        "softPrice": 4.61,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114412PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-NoUpFront",
        "price": 951.21,
        "softPrice": 1.3,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3Yrs-PartUpFront",
        "price": 2165.43,
        "softPrice": 2.97,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036PU"
    },
    {
        "name": "Oracle-14vCPU-112GB-1Yr-UpFront",
        "price": 3472.33,
        "softPrice": 4.76,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111212FU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3Yrs-PartUpFront",
        "price": 1948.89,
        "softPrice": 2.67,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-UpFront",
        "price": 87.16,
        "softPrice": 0.12,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212FU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-NoUpFront",
        "price": 281.88,
        "softPrice": 0.39,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 790.96,
        "softPrice": 1.08,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236PU"
    },
    {
        "name": "SharePoint-Server-SAL-for-SA-Ent",
        "price": 1.82,
        "softPrice": 0,
        "SKU": "CLMOBMS0SHPENT00MO"
    },
    {
        "name": "HANA-16vCPU-128GB-1Yr-NoUpFront",
        "price": 3022.4,
        "softPrice": 4.14,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112812MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-NoUpFront",
        "price": 2089.5,
        "softPrice": 2.86,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036MO"
    },
    {
        "name": "FWaaS-FortiNet-Enterprise-XXL",
        "price": 1194.75,
        "softPrice": 14152.59,
        "SKU": "CLLICFORFWEXXL12MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-UpFront",
        "price": 1049.82,
        "softPrice": 1.44,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 251.47,
        "softPrice": 0.34,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836FU"
    },
    {
        "name": "HANA-12vCPU-96GB-3Yrs-NoUpFront",
        "price": 1774.8,
        "softPrice": 2.43,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109636MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3Yrs-UpFront",
        "price": 90.76,
        "softPrice": 0.12,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436FU"
    },
    {
        "name": "HANA-64vCPU-256GB-3Yrs-UpFront",
        "price": 5423,
        "softPrice": 7.43,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125636FU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 1691.03,
        "softPrice": 2.32,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436MO"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 502.44,
        "softPrice": 0.69,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-NoUpFront",
        "price": 3496.13,
        "softPrice": 4.79,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212MO"
    },
    {
        "name": "MS-Exchange-Server-Ent",
        "price": 18.86,
        "softPrice": 0,
        "SKU": "CLLICMS0EXCENT00MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-PartUpFront",
        "price": 1923.26,
        "softPrice": 2.63,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012PU"
    },
    {
        "name": "Fedora",
        "price": 0,
        "softPrice": 0,
        "SKU": "LEILSEZH"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-UpFront",
        "price": 1261.38,
        "softPrice": 1.73,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612FU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-NoUpFront",
        "price": 657.25,
        "softPrice": 0.9,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-UpFront",
        "price": 1381.5,
        "softPrice": 1.89,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836FU"
    },
    {
        "name": "Oracle-8vCPU-32GB-3Yrs-NoUpFront",
        "price": 1703.74,
        "softPrice": 2.33,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103236MO"
    },
    {
        "name": "HANA-64vCPU-256GB-3Yrs-PartUpFront",
        "price": 5965.3,
        "softPrice": 8.17,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-UpFront",
        "price": 3490.2,
        "softPrice": 4.78,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436FU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 1160.85,
        "softPrice": 1.59,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212MO"
    },
    {
        "name": "HANA-14vCPU-112GB-3Yrs-UpFront",
        "price": 1684,
        "softPrice": 2.31,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111236FU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-PartUpFront",
        "price": 1730.93,
        "softPrice": 2.37,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212PU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-UpFront",
        "price": 1485.09,
        "softPrice": 2.03,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636FU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-PartUpFront",
        "price": 2673.84,
        "softPrice": 3.66,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612PU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 863.17,
        "softPrice": 1.18,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612FU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-NoUpFront",
        "price": 92.87,
        "softPrice": 0.13,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-PartUpFront",
        "price": 900.14,
        "softPrice": 1.23,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836PU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-On-Demand",
        "price": 1085.89,
        "softPrice": 1085.89,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201600MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-On-Demand",
        "price": 2150.18,
        "softPrice": 2150.18,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106400MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-NoUpFront",
        "price": 1445.95,
        "softPrice": 1.98,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 123.76,
        "softPrice": 0.17,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836FU"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-PartUpFront",
        "price": 2031.54,
        "softPrice": 2.78,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412PU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-NoUpFront",
        "price": 1421.54,
        "softPrice": 1.95,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036MO"
    },
    {
        "name": "WordPress",
        "price": 0,
        "softPrice": 0,
        "SKU": "KLKXEMZS"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 2958.74,
        "softPrice": 4.05,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412PU"
    },
    {
        "name": "Oracle-10vCPU-80GB-3Yrs-PartUpFront",
        "price": 2145.76,
        "softPrice": 2.94,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108036PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-NoUpFront",
        "price": 1279.39,
        "softPrice": 1.75,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236MO"
    },
    {
        "name": "Oracle-4vCPU-16GB-1Yr-NoUpFront",
        "price": 1183.56,
        "softPrice": 1.62,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101612MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-UpFront",
        "price": 1131.61,
        "softPrice": 1.55,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-On-Demand",
        "price": 3800.61,
        "softPrice": 3800.61,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205600MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-UpFront",
        "price": 907.55,
        "softPrice": 1.24,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036FU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-PartUpFront",
        "price": 1090.26,
        "softPrice": 1.49,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636PU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-On-Demand",
        "price": 1562.56,
        "softPrice": 1562.56,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202000MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-NoUpFront",
        "price": 1414.86,
        "softPrice": 1.94,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012MO"
    },
    {
        "name": "LAMP-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "YPWGMXLV"
    },
    {
        "name": "Oracle-16vCPU-128GB-3Yrs-UpFront",
        "price": 3106.14,
        "softPrice": 4.25,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112836FU"
    },
    {
        "name": "RedHat-OS-License-Small",
        "price": 248,
        "softPrice": 0,
        "SKU": "CLLICREDOSY00S00MO"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-UpFront",
        "price": 816.8,
        "softPrice": 1.12,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636FU"
    },
    {
        "name": "FwaaS-FortiNet-Advanced-Large",
        "price": 298.69,
        "softPrice": 1775.92,
        "SKU": "CLLICFORFWA00L12MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 1073.68,
        "softPrice": 1.47,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236MO"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-NoUpFront",
        "price": 4353.18,
        "softPrice": 5.96,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3Yrs-PartUpFront",
        "price": 3031.6,
        "softPrice": 4.15,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 298.69,
        "softPrice": 0.41,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-UpFront",
        "price": 2299.54,
        "softPrice": 3.15,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212FU"
    },
    {
        "name": "Exchange-aaS-50GB",
        "price": 49,
        "softPrice": 0,
        "SKU": "CLSASEMLEXC50G00MO"
    },
    {
        "name": "Oracle-40vCPU-160GB-1Yr-PartUpFront",
        "price": 9022,
        "softPrice": 12.36,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116012PU"
    },
    {
        "name": "Oracle-32vCPU-256GB-1Yr-UpFront",
        "price": 7631.39,
        "softPrice": 10.45,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125612FU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-UpFront",
        "price": 723.02,
        "softPrice": 0.99,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212FU"
    },
    {
        "name": "Oracle-12vCPU-96GB-1Yr-PartUpFront",
        "price": 3168.64,
        "softPrice": 4.34,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109612PU"
    },
    {
        "name": "Oracle-16vCPU-128GB-3Yrs-PartUpFront",
        "price": 3313.22,
        "softPrice": 4.54,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112836PU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 3101.9,
        "softPrice": 4.25,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412MO"
    },
    {
        "name": "Oracle-40vCPU-160GB-1Yr-NoUpFront",
        "price": 9473.1,
        "softPrice": 12.98,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116012MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 404.72,
        "softPrice": 0.55,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-UpFront",
        "price": 2326.8,
        "softPrice": 3.19,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636FU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 155.02,
        "softPrice": 0.21,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636FU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-On-Demand",
        "price": 2013.57,
        "softPrice": 2013.57,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105600MO"
    },
    {
        "name": "Oracle-8vCPU-32GB-1Yr-PartUpFront",
        "price": 2004.4,
        "softPrice": 2.75,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103212PU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-On-Demand",
        "price": 3274.08,
        "softPrice": 3274.08,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206000MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-On-Demand",
        "price": 3223.92,
        "softPrice": 3223.92,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204000MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-NoUpFront",
        "price": 185.74,
        "softPrice": 0.25,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3YrsNoUpFront",
        "price": 3125.36,
        "softPrice": 4.28,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-On-Demand",
        "price": 873.09,
        "softPrice": 873.09,
        "vcpu": "8",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201600MO"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-PartUpFront",
        "price": 924.84,
        "softPrice": 1.27,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636PU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-On-Demand",
        "price": 570.39,
        "softPrice": 570.39,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100400MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3YrsNoUpFront",
        "price": 2232.4,
        "softPrice": 3.06,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036MO"
    },
    {
        "name": "Oracle-8vCPU-64GB-3Yrs-NoUpFront",
        "price": 1866.4,
        "softPrice": 2.56,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106436MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-PartUpFront",
        "price": 1539.93,
        "softPrice": 2.11,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436PU"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 781.18,
        "softPrice": 1.07,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236PU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 936.21,
        "softPrice": 1.28,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 514,
        "softPrice": 0.7,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 1401.61,
        "softPrice": 1.92,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812FU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 473.21,
        "softPrice": 0.65,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-On-Demand",
        "price": 2284.46,
        "softPrice": 2284.46,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109600MO"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-PartUpFront",
        "price": 1354.36,
        "softPrice": 1.86,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612PU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-PartUpFront",
        "price": 1754.12,
        "softPrice": 2.4,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036PU"
    },
    {
        "name": "HANA-18vCPU-144GB-3Yrs-PartUpFront",
        "price": 2468.4,
        "softPrice": 3.38,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114436PU"
    },
    {
        "name": "Oracle-40vCPU-160GB-3Yrs-NoUpFront",
        "price": 7668.7,
        "softPrice": 10.51,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116036MO"
    },
    {
        "name": "Oracle-8vCPU-32GB-1Yr-UpFront",
        "price": 1904.18,
        "softPrice": 2.61,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103212FU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-NoUpFront",
        "price": 856.67,
        "softPrice": 1.17,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036MO"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-NoUpFront",
        "price": 1990.16,
        "softPrice": 2.73,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236MO"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-UpFront",
        "price": 2491.36,
        "softPrice": 3.41,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212FU"
    },
    {
        "name": "EntprStorageService-HANA-Oracle-GB",
        "price": 0.83,
        "softPrice": 0,
        "SKU": "CLSTOESSSTN00000MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-PartUpFront",
        "price": 2414.71,
        "softPrice": 3.31,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-PartUpFront",
        "price": 1984.6,
        "softPrice": 2.72,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3YrsNoUpFront",
        "price": 1562.68,
        "softPrice": 2.14,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636MO"
    },
    {
        "name": "FWaaS-FortiNet-UTM-XL",
        "price": 597.38,
        "softPrice": 5839.28,
        "SKU": "CLLICFORFWU0XL12MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-NoUpFront",
        "price": 921.57,
        "softPrice": 1.26,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036MO"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3Yrs-UpFront",
        "price": 1908.7,
        "softPrice": 2.61,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236FU"
    },
    {
        "name": "Oracle-32vCPU-256GB-1Yr-NoUpFront",
        "price": 8434.69,
        "softPrice": 11.55,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125612MO"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-UpFront",
        "price": 3321.81,
        "softPrice": 4.55,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-UpFront",
        "price": 1760.28,
        "softPrice": 2.41,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636FU"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 569.8,
        "softPrice": 0.78,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-PartUpFront",
        "price": 2531.39,
        "softPrice": 3.47,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212PU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 1056.96,
        "softPrice": 1.45,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436PU"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-On-Demand",
        "price": 2687.72,
        "softPrice": 2687.72,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108000MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 377.43,
        "softPrice": 0.52,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836FU"
    },
    {
        "name": "MySQL-Master-Master",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBMYS0MM00MO"
    },
    {
        "name": "Oracle-8vCPU-64GB-3Yrs-UpFront",
        "price": 1646.82,
        "softPrice": 2.26,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106436FU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-UpFront",
        "price": 1681.84,
        "softPrice": 2.3,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812FU"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 431.04,
        "softPrice": 0.59,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636FU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 848.31,
        "softPrice": 1.16,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236FU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-UpFront",
        "price": 2674.16,
        "softPrice": 3.66,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-UpFront",
        "price": 1123.85,
        "softPrice": 1.54,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812FU"
    },
    {
        "name": "Managed-Operating-System-Win",
        "price": 250,
        "softPrice": 0,
        "SKU": "CLMCSOSYWIN00000MO"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 514.37,
        "softPrice": 0.7,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636PU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-UpFront",
        "price": 866.3,
        "softPrice": 1.19,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-PartUpFront",
        "price": 2692.56,
        "softPrice": 3.69,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212PU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-On-Demand",
        "price": 2152.48,
        "softPrice": 2152.48,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104800MO"
    },
    {
        "name": "Oracle-2vCPU-8GB-1Yr-PartUpFront",
        "price": 688.6,
        "softPrice": 0.94,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100812PU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-PartUpFront",
        "price": 1367.07,
        "softPrice": 1.87,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636PU"
    },
    {
        "name": "Oracle-10vCPU-40GB-1Yr-NoUpFront",
        "price": 2565.15,
        "softPrice": 3.51,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104012MO"
    },
    {
        "name": "FwaaS-FortiNet-Basic-Small",
        "price": 74.67,
        "softPrice": 611.79,
        "SKU": "CLLICFORFWB00S12MO"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-NoUpFront",
        "price": 2686.68,
        "softPrice": 3.68,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-UpFront",
        "price": 649.7,
        "softPrice": 0.89,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036FU"
    },
    {
        "name": "OpenCart",
        "price": 0,
        "softPrice": 0,
        "SKU": "MFWBDKFF"
    },
    {
        "name": "DETASAD-Cloud-Migartion-Service-VM",
        "price": 900,
        "softPrice": 0,
        "SKU": "CLMGSDTS0VM00000MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-PartUpFront",
        "price": 699.04,
        "softPrice": 0.96,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-On-Demand",
        "price": 1357.36,
        "softPrice": 1357.36,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202000MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 696.89,
        "softPrice": 0.95,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-UpFront",
        "price": 2138.13,
        "softPrice": 2.93,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236FU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-NoUpFront",
        "price": 2171.65,
        "softPrice": 2.97,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636MO"
    },
    {
        "name": "Oracle-10vCPU-40GB-3Yrs-UpFront",
        "price": 1832.25,
        "softPrice": 2.51,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104036FU"
    },
    {
        "name": "SuiteCRM-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "VFMQGRCA"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3YrsNoUpFront",
        "price": 1339.44,
        "softPrice": 1.83,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836MO"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3Yrs-PartUpFront",
        "price": 2598.51,
        "softPrice": 3.56,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636PU"
    },
    {
        "name": "Django-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "OAWCKCUH"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-PartUpFront",
        "price": 142.45,
        "softPrice": 0.2,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3YrsNoUpFront",
        "price": 52.84,
        "softPrice": 0.07,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236MO"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-NoUpFront",
        "price": 262.9,
        "softPrice": 0.36,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-NoUpFront",
        "price": 870.64,
        "softPrice": 1.19,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 1252.88,
        "softPrice": 1.72,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436PU"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 119.66,
        "softPrice": 0.16,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-PartUpFront",
        "price": 3440.28,
        "softPrice": 4.71,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812PU"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-On-Demand",
        "price": 3257.66,
        "softPrice": 3257.66,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204800MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-3Yrs-NoUpFront",
        "price": 1183.05,
        "softPrice": 1.62,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203636MO"
    },
    {
        "name": "Oracle-2vCPU-16GB-3Yrs-NoUpFront",
        "price": 625.97,
        "softPrice": 0.86,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101636MO"
    },
    {
        "name": "Oracle-14vCPU-112GB-1Yr-PartUpFront",
        "price": 3655.08,
        "softPrice": 5.01,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111212PU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-NoUpFront",
        "price": 2786.16,
        "softPrice": 3.82,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 478.65,
        "softPrice": 0.66,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212MO"
    },
    {
        "name": "Oracle-12vCPU-48GB-On-Demand",
        "price": 3457.92,
        "softPrice": 3457.92,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104800MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-NoUpFront",
        "price": 1373.96,
        "softPrice": 1.88,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-On-Demand",
        "price": 380.74,
        "softPrice": 380.74,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101600MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-NoUpFront",
        "price": 2649.32,
        "softPrice": 3.63,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-UpFront",
        "price": 1395.15,
        "softPrice": 1.91,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-PartUpFront",
        "price": 1800.29,
        "softPrice": 2.47,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636PU"
    },
    {
        "name": "Oracle-16vCPU-64GB-3Yrs-UpFront",
        "price": 2819.1,
        "softPrice": 3.86,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106436FU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-On-Demand",
        "price": 3739.49,
        "softPrice": 3739.49,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110400MO"
    },
    {
        "name": "Oracle-2vCPU-16GB-1Yr-UpFront",
        "price": 699.62,
        "softPrice": 0.96,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101612FU"
    },
    {
        "name": "Windows-Server-Starndard-Core-2-Core",
        "price": 24.64,
        "softPrice": 0,
        "SKU": "CLLICMS0WINSTD00MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-UpFront",
        "price": 140.15,
        "softPrice": 0.19,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-NoUpFront",
        "price": 739.83,
        "softPrice": 1.01,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-UpFront",
        "price": 174.31,
        "softPrice": 0.24,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412FU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-NoUpFront",
        "price": 1011.8,
        "softPrice": 1.39,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012MO"
    },
    {
        "name": "Oracle-64vCPU-256GB-On-Demand",
        "price": 17142.24,
        "softPrice": 17142.24,
        "vcpu": "64",
        "ram": "256",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125600MO"
    },
    {
        "name": "Oracle-40vCPU-160GB-1Yr-UpFront",
        "price": 8570.9,
        "softPrice": 11.74,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116012FU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1272.47,
        "softPrice": 1.74,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836FU"
    },
    {
        "name": "HANA-10vCPU-80GB-3Yrs-NoUpFront",
        "price": 1528.8,
        "softPrice": 2.09,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108036MO"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-On-Demand",
        "price": 4106.74,
        "softPrice": 4106.74,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108800MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1543.1,
        "softPrice": 2.11,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-UpFront",
        "price": 775.09,
        "softPrice": 1.06,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-UpFront",
        "price": 1143.48,
        "softPrice": 1.57,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412FU"
    },
    {
        "name": "FWaaS-FortiNet-UTM-Large",
        "price": 298.69,
        "softPrice": 2076.08,
        "SKU": "CLLICFORFWU00L12MO"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-3YrsNoUpFront",
        "price": 2009.16,
        "softPrice": 2.75,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107236MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-On-Demand",
        "price": 4315.28,
        "softPrice": 4315.28,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206000MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-1Yr-NoUpFront",
        "price": 1644.09,
        "softPrice": 2.25,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102412MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-NoUpFront",
        "price": 448.03,
        "softPrice": 0.61,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 726.04,
        "softPrice": 0.99,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-PartUpFront",
        "price": 997.16,
        "softPrice": 1.37,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-On-Demand",
        "price": 761.49,
        "softPrice": 761.49,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103200MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-NoUpFront",
        "price": 2090.82,
        "softPrice": 2.86,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612MO"
    },
    {
        "name": "Windows-Server",
        "price": 0,
        "softPrice": 0.19,
        "SKU": "CDCQKNDV"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 2126.05,
        "softPrice": 2.91,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812PU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-PartUpFront",
        "price": 592.28,
        "softPrice": 0.81,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436PU"
    },
    {
        "name": "Managed-Tomcat",
        "price": 700,
        "softPrice": 0,
        "SKU": "CLMCSWEBTOM00000MO"
    },
    {
        "name": "Oracle-6vCPU-48GB-On-Demand",
        "price": 2051.18,
        "softPrice": 2051.18,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104800MO"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 1538.61,
        "softPrice": 2.11,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412PU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-UpFront",
        "price": 453.78,
        "softPrice": 0.62,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036FU"
    },
    {
        "name": "MySQL-Standalone",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBMYSSTA00MO"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-NoUpFront",
        "price": 1162.59,
        "softPrice": 1.59,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436MO"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3Yrs-UpFront",
        "price": 106.04,
        "softPrice": 0.15,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436FU"
    },
    {
        "name": "HANA-18vCPU-144GB-3Yrs-NoUpFront",
        "price": 2692.8,
        "softPrice": 3.69,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114436MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-3Yrs-PartUpFront",
        "price": 1405.73,
        "softPrice": 1.93,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112836PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3YrsNoUpFront",
        "price": 3571.84,
        "softPrice": 4.89,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836MO"
    },
    {
        "name": "ELK-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "QUXKDYMW"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 1766.22,
        "softPrice": 2.42,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412MO"
    },
    {
        "name": "HANA-14vCPU-112GB-1Yr-NoUpFront",
        "price": 2694.4,
        "softPrice": 3.69,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111212MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-NoUpFront",
        "price": 788.7,
        "softPrice": 1.08,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436MO"
    },
    {
        "name": "Oracle-10vCPU-40GB-3Yrs-NoUpFront",
        "price": 2076.55,
        "softPrice": 2.84,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104036MO"
    },
    {
        "name": "Ubuntu",
        "price": 0,
        "softPrice": 0,
        "SKU": "IRPHBNRK"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-On-Demand",
        "price": 1309.63,
        "softPrice": 1309.63,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202400MO"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 352.95,
        "softPrice": 0.48,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-UpFront",
        "price": 61.88,
        "softPrice": 0.08,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-On-Demand",
        "price": 2301.22,
        "softPrice": 2301.22,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106400MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-NoUpFront",
        "price": 131.45,
        "softPrice": 0.18,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 1171.78,
        "softPrice": 1.61,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-NoUpFront",
        "price": 1028.01,
        "softPrice": 1.41,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-UpFront",
        "price": 1121.23,
        "softPrice": 1.54,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212FU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 677.18,
        "softPrice": 0.93,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812PU"
    },
    {
        "name": "Joomla-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "HLZPKURW"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-PartUpFront",
        "price": 3402.18,
        "softPrice": 4.66,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612PU"
    },
    {
        "name": "DokuWiki-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "UYTLGVPN"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-NoUpFront",
        "price": 1666.75,
        "softPrice": 2.28,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436MO"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-PartUpFront",
        "price": 488.24,
        "softPrice": 0.67,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036PU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-NoUpFront",
        "price": 2056.5,
        "softPrice": 2.82,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612MO"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-PartUpFront",
        "price": 946.42,
        "softPrice": 1.3,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636PU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-PartUpFront",
        "price": 1261.89,
        "softPrice": 1.73,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836PU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3YrsNoUpFront",
        "price": 223.24,
        "softPrice": 0.31,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836MO"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-NoUpFront",
        "price": 1612.63,
        "softPrice": 2.21,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-NoUpFront",
        "price": 1514.24,
        "softPrice": 2.07,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812MO"
    },
    {
        "name": "MS-SQL-Server-Ent",
        "price": 3090.11,
        "softPrice": 0,
        "SKU": "CLLICMS0SQLENT00MO"
    },
    {
        "name": "Oracle-4vCPU-32GB-1Yr-NoUpFront",
        "price": 1284.02,
        "softPrice": 1.76,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103212MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-UpFront",
        "price": 1987.42,
        "softPrice": 2.72,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812FU"
    },
    {
        "name": "Oracle-8vCPU-32GB-3Yrs-PartUpFront",
        "price": 1603.52,
        "softPrice": 2.2,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103236PU"
    },
    {
        "name": "Oracle-12vCPU-48GB-1Yr-PartUpFront",
        "price": 2881.6,
        "softPrice": 3.95,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104812PU"
    },
    {
        "name": "HANA-12vCPU-96GB-1Yr-NoUpFront",
        "price": 2366.4,
        "softPrice": 3.24,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109612MO"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-UpFront",
        "price": 209.26,
        "softPrice": 0.29,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-UpFront",
        "price": 2486.85,
        "softPrice": 3.41,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012FU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-NoUpFront",
        "price": 1367.81,
        "softPrice": 1.87,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-PartUpFront",
        "price": 1580.09,
        "softPrice": 2.16,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212PU"
    },
    {
        "name": "Oracle-8vCPU-32GB-3Yrs-UpFront",
        "price": 1503.3,
        "softPrice": 2.06,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103236FU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 2028.17,
        "softPrice": 2.78,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436PU"
    },
    {
        "name": "HANA-14vCPU-112GB-On-Demand",
        "price": 3704.8,
        "softPrice": 3704.8,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111200MO"
    },
    {
        "name": "HANA-16vCPU-128GB-1Yr-UpFront",
        "price": 2644.6,
        "softPrice": 3.62,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112812FU"
    },
    {
        "name": "HANA-32vCPU-256GB-1Yr-NoUpFront",
        "price": 5886.4,
        "softPrice": 8.06,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125612MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-PartUpFront",
        "price": 660.6,
        "softPrice": 0.9,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-PartUpFront",
        "price": 2104.03,
        "softPrice": 2.88,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012PU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-On-Demand",
        "price": 689.47,
        "softPrice": 689.47,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200400MO"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-NoUpFront",
        "price": 281,
        "softPrice": 0.38,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236MO"
    },
    {
        "name": "Managed-Apache",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCSWEBAPA00000MO"
    },
    {
        "name": "HANA-32vCPU-256GB-On-Demand",
        "price": 8093.8,
        "softPrice": 8093.8,
        "vcpu": "32",
        "ram": "256",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125600MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-On-Demand",
        "price": 3164.18,
        "softPrice": 3164.18,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108800MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 495.03,
        "softPrice": 0.68,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236FU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3YrsNoUpFront",
        "price": 105.69,
        "softPrice": 0.14,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 342.67,
        "softPrice": 0.47,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236MO"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 451.45,
        "softPrice": 0.62,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212PU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-UpFront",
        "price": 1890.61,
        "softPrice": 2.59,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636FU"
    },
    {
        "name": "Oracle-2vCPU-8GB-3Yrs-NoUpFront",
        "price": 585.31,
        "softPrice": 0.8,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100836MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-NoUpFront",
        "price": 3225.26,
        "softPrice": 4.42,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-UpFront",
        "price": 377.2,
        "softPrice": 0.52,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236FU"
    },
    {
        "name": "HANA-40vCPU-160GB-3Yrs-UpFront",
        "price": 3539,
        "softPrice": 4.85,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116036FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 314.86,
        "softPrice": 0.43,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812FU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-UpFront",
        "price": 1270.57,
        "softPrice": 1.74,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636FU"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-UpFront",
        "price": 2385.64,
        "softPrice": 3.27,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-UpFront",
        "price": 1732.61,
        "softPrice": 2.37,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236FU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 649.37,
        "softPrice": 0.89,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-UpFront",
        "price": 1856.36,
        "softPrice": 2.54,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036FU"
    },
    {
        "name": "Oracle-64vCPU-256GB-1Yr-PartUpFront",
        "price": 14285.2,
        "softPrice": 19.57,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125612PU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-NoUpFront",
        "price": 862.3,
        "softPrice": 1.18,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-PartUpFront",
        "price": 3322.76,
        "softPrice": 4.55,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212PU"
    },
    {
        "name": "FWaaS-FortiNet-Enterprise-XL",
        "price": 597.38,
        "softPrice": 6683.51,
        "SKU": "CLLICFORFWE0XL12MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-UpFront",
        "price": 2490.56,
        "softPrice": 3.41,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212FU"
    },
    {
        "name": "RedHat-OS-License-Large",
        "price": 548,
        "softPrice": 0,
        "SKU": "CLLICREDOSY00L00MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-PartUpFront",
        "price": 2816.29,
        "softPrice": 3.86,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012PU"
    },
    {
        "name": "FWaaS-FortiNet-Advanced-XXL",
        "price": 1194.75,
        "softPrice": 10577.2,
        "SKU": "CLLICFORFWAXXL12MO"
    },
    {
        "name": "HANA-18vCPU-144GB-1Yr-UpFront",
        "price": 3141.6,
        "softPrice": 4.3,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114412FU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-NoUpFront",
        "price": 2029.49,
        "softPrice": 2.78,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-NoUpFront",
        "price": 1455.37,
        "softPrice": 1.99,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-On-Demand",
        "price": 2631.66,
        "softPrice": 2631.66,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109600MO"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-NoUpFront",
        "price": 1051.6,
        "softPrice": 1.44,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236MO"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-NoUpFront",
        "price": 928.72,
        "softPrice": 1.27,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-UpFront",
        "price": 374.62,
        "softPrice": 0.51,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612FU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-On-Demand",
        "price": 1150.61,
        "softPrice": 1150.61,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103200MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-1Yr-NoUpFront",
        "price": 149.34,
        "softPrice": 0.2,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200412MO"
    },
    {
        "name": "HANA-16vCPU-128GB-3Yrs-NoUpFront",
        "price": 2266.8,
        "softPrice": 3.11,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112836MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-PartUpFront",
        "price": 427.35,
        "softPrice": 0.59,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212PU"
    },
    {
        "name": "HANA-14vCPU-112GB-3Yrs-NoUpFront",
        "price": 2020.8,
        "softPrice": 2.77,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111236MO"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-On-Demand",
        "price": 4602.44,
        "softPrice": 4602.44,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112800MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-UpFront",
        "price": 1634.55,
        "softPrice": 2.24,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236FU"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-UpFront",
        "price": 1045.88,
        "softPrice": 1.43,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3Yrs-PartUpFront",
        "price": 108.27,
        "softPrice": 0.15,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-PartUpFront",
        "price": 2551.63,
        "softPrice": 3.5,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212PU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 239.32,
        "softPrice": 0.33,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612MO"
    },
    {
        "name": "Oracle-4vCPU-32GB-1Yr-PartUpFront",
        "price": 1222.88,
        "softPrice": 1.68,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103212PU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-NoUpFront",
        "price": 3237.77,
        "softPrice": 4.44,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-On-Demand",
        "price": 1628.83,
        "softPrice": 1628.83,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202400MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-PartUpFront",
        "price": 1344.63,
        "softPrice": 1.84,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636PU"
    },
    {
        "name": "Oracle-64vCPU-256GB-1Yr-UpFront",
        "price": 13570.94,
        "softPrice": 18.59,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125612FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-PartUpFront",
        "price": 712.26,
        "softPrice": 0.98,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012PU"
    },
    {
        "name": "Security-Monitoring-Server-Log",
        "price": 259,
        "softPrice": 0,
        "SKU": "CLMCSSECMON00000MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 883.11,
        "softPrice": 1.21,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 1732.34,
        "softPrice": 2.37,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436PU"
    },
    {
        "name": "HANA-64vCPU-512GB-3Yrs-NoUpFront",
        "price": 8350.8,
        "softPrice": 11.44,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151236MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-NoUpFront",
        "price": 2902.12,
        "softPrice": 3.98,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-PartUpFront",
        "price": 2546.83,
        "softPrice": 3.49,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-On-Demand",
        "price": 3531.44,
        "softPrice": 3531.44,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107200MO"
    },
    {
        "name": "Oracle-16vCPU-128GB-3Yrs-NoUpFront",
        "price": 3520.29,
        "softPrice": 4.82,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112836MO"
    },
    {
        "name": "Oracle-12vCPU-96GB-3Yrs-NoUpFront",
        "price": 2693.34,
        "softPrice": 3.69,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109636MO"
    },
    {
        "name": "Oracle-32vCPU-256GB-3Yrs-PartUpFront",
        "price": 6426.43,
        "softPrice": 8.8,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125636PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 1701.09,
        "softPrice": 2.33,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 582.87,
        "softPrice": 0.8,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812FU"
    },
    {
        "name": "Ruby-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "IGWVLVQQ"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-UpFront",
        "price": 1498.47,
        "softPrice": 2.05,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-On-Demand",
        "price": 4314.79,
        "softPrice": 4314.79,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112000MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-UpFront",
        "price": 371.41,
        "softPrice": 0.51,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412FU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 296.38,
        "softPrice": 0.41,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636FU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 212.08,
        "softPrice": 0.29,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 307.28,
        "softPrice": 0.42,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 354.34,
        "softPrice": 0.49,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-UpFront",
        "price": 93.65,
        "softPrice": 0.13,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412FU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-PartUpFront",
        "price": 1128.63,
        "softPrice": 1.55,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012PU"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-On-Demand",
        "price": 1001.87,
        "softPrice": 1001.87,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101600MO"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-PartUpFront",
        "price": 71.23,
        "softPrice": 0.1,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212PU"
    },
    {
        "name": "Oracle-6vCPU-48GB-1Yr-NoUpFront",
        "price": 1794.79,
        "softPrice": 2.46,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104812MO"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-PartUpFront",
        "price": 2938.11,
        "softPrice": 4.02,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612PU"
    },
    {
        "name": "HANA-64vCPU-512GB-3Yrs-PartUpFront",
        "price": 7654.9,
        "softPrice": 10.49,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151236PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-PartUpFront",
        "price": 885.86,
        "softPrice": 1.21,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012PU"
    },
    {
        "name": "MS-SharePoint-Server-Std",
        "price": 16.29,
        "softPrice": 0,
        "SKU": "CLLICMS0SHPSTD00MO"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-NoUpFront",
        "price": 3192.33,
        "softPrice": 4.37,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812MO"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-On-Demand",
        "price": 109.14,
        "softPrice": 109.14,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200200MO"
    },
    {
        "name": "MS-SQL-Standalone",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBSQLSTA00MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-1Yr-NoUpFront",
        "price": 2653.87,
        "softPrice": 3.64,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205212MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 1054.5,
        "softPrice": 1.44,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-On-Demand",
        "price": 143.83,
        "softPrice": 143.83,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100400MO"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-3Yrs-NoUpFront",
        "price": 1840.29,
        "softPrice": 2.52,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205636MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 2195.19,
        "softPrice": 3.01,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-NoUpFront",
        "price": 1848,
        "softPrice": 2.53,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-UpFront",
        "price": 2210.25,
        "softPrice": 3.03,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412FU"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-On-Demand",
        "price": 5545,
        "softPrice": 5545,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112800MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-PartUpFront",
        "price": 2246.48,
        "softPrice": 3.08,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412PU"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-1Yr-NoUpFront",
        "price": 2355.18,
        "softPrice": 3.23,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204412MO"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-UpFront",
        "price": 2247.71,
        "softPrice": 3.08,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612FU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 257.18,
        "softPrice": 0.35,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200836PU"
    },
    {
        "name": "FwaaS-FortiNet-Basic-XL",
        "price": 597.38,
        "softPrice": 3939.75,
        "SKU": "CLLICFORFWB0XL12MO"
    },
    {
        "name": "HANA-8vCPU-64GB-3Yrs-UpFront",
        "price": 1069,
        "softPrice": 1.46,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106436FU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3Yrs-UpFront",
        "price": 2757.01,
        "softPrice": 3.78,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-UpFront",
        "price": 372.64,
        "softPrice": 0.51,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212FU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-PartUpFront",
        "price": 1346.28,
        "softPrice": 1.84,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612PU"
    },
    {
        "name": "HANA-10vCPU-80GB-On-Demand",
        "price": 2802.8,
        "softPrice": 2802.8,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108000MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-UpFront",
        "price": 837.03,
        "softPrice": 1.15,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-On-Demand",
        "price": 1091.36,
        "softPrice": 1091.36,
        "vcpu": "10",
        "ram": "20",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202000MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-PartUpFront",
        "price": 449.97,
        "softPrice": 0.62,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412PU"
    },
    {
        "name": "Oracle-2vCPU-16GB-1Yr-PartUpFront",
        "price": 736.44,
        "softPrice": 1.01,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101612PU"
    },
    {
        "name": "Oracle-64vCPU-512GB-3Yrs-NoUpFront",
        "price": 13443.67,
        "softPrice": 18.42,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151236MO"
    },
    {
        "name": "FWaaS-FortiNet-Enterprise-Medium",
        "price": 149.34,
        "softPrice": 1158.77,
        "SKU": "CLLICFORFWE00M12MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-PartUpFront",
        "price": 531.51,
        "softPrice": 0.73,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212PU"
    },
    {
        "name": "HANA-64vCPU-256GB-1Yr-NoUpFront",
        "price": 8676.8,
        "softPrice": 11.89,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125612MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 284.31,
        "softPrice": 0.39,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636MO"
    },
    {
        "name": "Oracle-4vCPU-16GB-3Yrs-NoUpFront",
        "price": 958.12,
        "softPrice": 1.31,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101636MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-NoUpFront",
        "price": 2630.69,
        "softPrice": 3.6,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412MO"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-UpFront",
        "price": 2440.39,
        "softPrice": 3.34,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 630.95,
        "softPrice": 0.86,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-NoUpFront",
        "price": 65.72,
        "softPrice": 0.09,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236MO"
    },
    {
        "name": "Oracle-16vCPU-64GB-1Yr-NoUpFront",
        "price": 3946.74,
        "softPrice": 5.41,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106412MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-PartUpFront",
        "price": 292.94,
        "softPrice": 0.4,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-PartUpFront",
        "price": 3685.69,
        "softPrice": 5.05,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412PU"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1508.81,
        "softPrice": 2.07,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836FU"
    },
    {
        "name": "Oracle-12vCPU-48GB-1Yr-NoUpFront",
        "price": 3025.68,
        "softPrice": 4.14,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104812MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-NoUpFront",
        "price": 1585.34,
        "softPrice": 2.17,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036MO"
    },
    {
        "name": "MS-Exchange-Server-Ent-Plus",
        "price": 27.21,
        "softPrice": 0,
        "SKU": "CLLICMS0EXCENP00MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-PartUpFront",
        "price": 1994.32,
        "softPrice": 2.73,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-On-Demand",
        "price": 2303.84,
        "softPrice": 2303.84,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-PartUpFront",
        "price": 894.34,
        "softPrice": 1.23,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836PU"
    },
    {
        "name": "Oracle-64vCPU-512GB-1Yr-NoUpFront",
        "price": 16606.88,
        "softPrice": 22.75,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151212MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-UpFront",
        "price": 2060.4,
        "softPrice": 2.82,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-UpFront",
        "price": 1643.1,
        "softPrice": 2.25,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036FU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3Yrs-PartUpFront",
        "price": 48.82,
        "softPrice": 0.07,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236PU"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-UpFront",
        "price": 2266.08,
        "softPrice": 3.1,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-UpFront",
        "price": 2456.42,
        "softPrice": 3.36,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412FU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-PartUpFront",
        "price": 774.79,
        "softPrice": 1.06,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 621.09,
        "softPrice": 0.85,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812MO"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-On-Demand",
        "price": 3442.19,
        "softPrice": 3442.19,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204400MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-3Yrs-UpFront",
        "price": 2120.78,
        "softPrice": 2.91,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108036FU"
    },
    {
        "name": "FWaaS-FortiNet-UTM-XXL",
        "price": 1194.75,
        "softPrice": 12364.89,
        "SKU": "CLLICFORFWUXXL12MO"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-NoUpFront",
        "price": 907.16,
        "softPrice": 1.24,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412MO"
    },
    {
        "name": "MS-Hosted-Exchange-SAL-for-SA-Ent",
        "price": 1.5,
        "softPrice": 0,
        "SKU": "CLMOBMS0EXCENT00MO"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-PartUpFront",
        "price": 1737.47,
        "softPrice": 2.38,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-PartUpFront",
        "price": 1189.08,
        "softPrice": 1.63,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 457.56,
        "softPrice": 0.63,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-3Yrs-NoUpFront",
        "price": 1577.4,
        "softPrice": 2.16,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204836MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 451.39,
        "softPrice": 0.62,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236FU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 327.57,
        "softPrice": 0.45,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636MO"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 990.06,
        "softPrice": 1.36,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-UpFront",
        "price": 418.52,
        "softPrice": 0.57,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612FU"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-On-Demand",
        "price": 1489.43,
        "softPrice": 1489.43,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104800MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-NoUpFront",
        "price": 401.26,
        "softPrice": 0.55,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 1696.62,
        "softPrice": 2.32,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-PartUpFront",
        "price": 3077.22,
        "softPrice": 4.22,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-UpFront",
        "price": 561.93,
        "softPrice": 0.77,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 2011.75,
        "softPrice": 2.76,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436FU"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 1137.23,
        "softPrice": 1.56,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106436MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-PartUpFront",
        "price": 1453.32,
        "softPrice": 1.99,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836PU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-On-Demand",
        "price": 537.57,
        "softPrice": 537.57,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100800MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 1885,
        "softPrice": 2.58,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206436FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-NoUpFront",
        "price": 145.11,
        "softPrice": 0.2,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-NoUpFront",
        "price": 202.36,
        "softPrice": 0.28,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812MO"
    },
    {
        "name": "MongoDB-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "NAOFBLQZ"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-NoUpFront",
        "price": 2636.16,
        "softPrice": 3.61,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-UpFront",
        "price": 276.82,
        "softPrice": 0.38,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812FU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-NoUpFront",
        "price": 2023.6,
        "softPrice": 2.77,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012MO"
    },
    {
        "name": "Oracle-32vCPU-128GB-1Yr-NoUpFront",
        "price": 7630.98,
        "softPrice": 10.45,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112812MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 495.11,
        "softPrice": 0.68,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-UpFront",
        "price": 111.5,
        "softPrice": 0.15,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812FU"
    },
    {
        "name": "Managed-Router",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCSNETROU00000MO"
    },
    {
        "name": "Oracle-12vCPU-48GB-3Yrs-PartUpFront",
        "price": 2305.28,
        "softPrice": 3.16,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104836PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-On-Demand",
        "price": 1964.45,
        "softPrice": 1964.45,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203600MO"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3YrsNoUpFront",
        "price": 892.96,
        "softPrice": 1.22,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-PartUpFront",
        "price": 1334.47,
        "softPrice": 1.83,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012PU"
    },
    {
        "name": "Oracle-14vCPU-112GB-3Yrs-NoUpFront",
        "price": 3106.82,
        "softPrice": 4.26,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111236MO"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-NoUpFront",
        "price": 2274.46,
        "softPrice": 3.12,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836MO"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 264.24,
        "softPrice": 0.36,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-NoUpFront",
        "price": 3628.42,
        "softPrice": 4.97,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-UpFront",
        "price": 2511.1,
        "softPrice": 3.44,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612FU"
    },
    {
        "name": "Oracle-8vCPU-64GB-1Yr-NoUpFront",
        "price": 2305.55,
        "softPrice": 3.16,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106412MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-NoUpFront",
        "price": 394.35,
        "softPrice": 0.54,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-UpFront",
        "price": 553.64,
        "softPrice": 0.76,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612FU"
    },
    {
        "name": "Oracle-2vCPU-8GB-3Yrs-PartUpFront",
        "price": 550.88,
        "softPrice": 0.75,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100836PU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-On-Demand",
        "price": 3045.95,
        "softPrice": 3045.95,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112800MO"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-On-Demand",
        "price": 135.74,
        "softPrice": 135.74,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200200MO"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-On-Demand",
        "price": 268.77,
        "softPrice": 268.77,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100800MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-PartUpFront",
        "price": 3010.25,
        "softPrice": 4.12,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 1108.75,
        "softPrice": 1.52,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412PU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-NoUpFront",
        "price": 2833.05,
        "softPrice": 3.88,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212MO"
    },
    {
        "name": "SharePoint-Server-SAL-for-SA-Std",
        "price": 1.82,
        "softPrice": 0,
        "SKU": "CLMOBMS0SHPSTD00MO"
    },
    {
        "name": "MS-Exchange-Server-Std-Plus",
        "price": 20.14,
        "softPrice": 0,
        "SKU": "CLLICMS0EXCSTP00MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 809.44,
        "softPrice": 1.11,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-PartUpFront",
        "price": 1419.63,
        "softPrice": 1.94,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436PU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-NoUpFront",
        "price": 557.23,
        "softPrice": 0.76,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212MO"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-On-Demand",
        "price": 1612.63,
        "softPrice": 1612.63,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104800MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-PartUpFront",
        "price": 1930.52,
        "softPrice": 2.64,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-NoUpFront",
        "price": 1561.06,
        "softPrice": 2.14,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-3Yrs-NoUpFront",
        "price": 1479.65,
        "softPrice": 2.03,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205636MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-On-Demand",
        "price": 2837.54,
        "softPrice": 2837.54,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205200MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-PartUpFront",
        "price": 1671.7,
        "softPrice": 2.29,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-On-Demand",
        "price": 1870.18,
        "softPrice": 1870.18,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106400MO"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3YrsNoUpFront",
        "price": 211.38,
        "softPrice": 0.29,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836MO"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-PartUpFront",
        "price": 734.87,
        "softPrice": 1.01,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212PU"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-PartUpFront",
        "price": 1442.28,
        "softPrice": 1.98,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-On-Demand",
        "price": 436.54,
        "softPrice": 436.54,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-UpFront",
        "price": 1220.2,
        "softPrice": 1.67,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812FU"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-1Yr-PartUpFront",
        "price": 177.17,
        "softPrice": 0.24,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200412PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-NoUpFront",
        "price": 634.14,
        "softPrice": 0.87,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436MO"
    },
    {
        "name": "Oracle-10vCPU-80GB-1Yr-NoUpFront",
        "price": 2816.31,
        "softPrice": 3.86,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108012MO"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-UpFront",
        "price": 3598.63,
        "softPrice": 4.93,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412FU"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 2350.4,
        "softPrice": 3.22,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812FU"
    },
    {
        "name": "HANA-18vCPU-144GB-1Yr-NoUpFront",
        "price": 3590.4,
        "softPrice": 4.92,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114412MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-PartUpFront",
        "price": 1246.83,
        "softPrice": 1.71,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012PU"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-3Yrs-PartUpFront",
        "price": 97.65,
        "softPrice": 0.13,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200436PU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 866.17,
        "softPrice": 1.19,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103236PU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-NoUpFront",
        "price": 746.72,
        "softPrice": 1.02,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-UpFront",
        "price": 1541.4,
        "softPrice": 2.11,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612FU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-NoUpFront",
        "price": 1821.24,
        "softPrice": 2.49,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212MO"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-UpFront",
        "price": 1703.49,
        "softPrice": 2.33,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636FU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-UpFront",
        "price": 1551.2,
        "softPrice": 2.12,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436FU"
    },
    {
        "name": "MS-SQL-Server-Std",
        "price": 805.82,
        "softPrice": 0,
        "SKU": "CLLICMS0SQLSTD00MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-UpFront",
        "price": 1361.33,
        "softPrice": 1.86,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-NoUpFront",
        "price": 1705.85,
        "softPrice": 2.34,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636MO"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-On-Demand",
        "price": 862.96,
        "softPrice": 862.96,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102400MO"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-3Yrs-PartUpFront",
        "price": 1849.67,
        "softPrice": 2.53,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111236PU"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-3Yrs-UpFront",
        "price": 1794.25,
        "softPrice": 2.46,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206036FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 220.78,
        "softPrice": 0.3,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100812MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 112.86,
        "softPrice": 0.15,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100812PU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 284.9,
        "softPrice": 0.39,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812PU"
    },
    {
        "name": "FWaaS-FortiNet-Enterprise-Large",
        "price": 298.69,
        "softPrice": 2376.23,
        "SKU": "CLLICFORFWE00L12MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-On-Demand",
        "price": 4300.35,
        "softPrice": 4300.35,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-On-Demand",
        "price": 1900.3,
        "softPrice": 1900.3,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202800MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 1063.72,
        "softPrice": 1.46,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836MO"
    },
    {
        "name": "HANA-8vCPU-64GB-3Yrs-PartUpFront",
        "price": 1175.9,
        "softPrice": 1.61,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106436PU"
    },
    {
        "name": "Oracle-10vCPU-80GB-3Yrs-NoUpFront",
        "price": 2279.87,
        "softPrice": 3.12,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108036MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 652.38,
        "softPrice": 0.89,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-UpFront",
        "price": 802.31,
        "softPrice": 1.1,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036FU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-PartUpFront",
        "price": 2361.13,
        "softPrice": 3.23,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212PU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-UpFront",
        "price": 831.21,
        "softPrice": 1.14,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836FU"
    },
    {
        "name": "Node.JS-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "KXFLCFER"
    },
    {
        "name": "DETASAD-Cloud-DR-Service-VM",
        "price": 135,
        "softPrice": 0,
        "SKU": "CLDRSDTS0VM00000MO"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 1175.54,
        "softPrice": 1.61,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412MO"
    },
    {
        "name": "ECS-2vCPU-4GB-Linux-On-Demand",
        "price": 218.27,
        "softPrice": 218.27,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200400MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-On-Demand",
        "price": 3005.65,
        "softPrice": 3005.65,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203600MO"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-1Yr-PartUpFront",
        "price": 381.36,
        "softPrice": 0.52,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100412PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-PartUpFront",
        "price": 66.06,
        "softPrice": 0.09,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436PU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-NoUpFront",
        "price": 1314.5,
        "softPrice": 1.8,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036MO"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3Yrs-UpFront",
        "price": 3181.17,
        "softPrice": 4.36,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036FU"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-1Yr-UpFront",
        "price": 2622.32,
        "softPrice": 3.59,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111212FU"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-UpFront",
        "price": 125.73,
        "softPrice": 0.17,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436FU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-PartUpFront",
        "price": 576.98,
        "softPrice": 0.79,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412PU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-1Yr-UpFront",
        "price": 2996.94,
        "softPrice": 4.11,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112812FU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 1452.08,
        "softPrice": 1.99,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436FU"
    },
    {
        "name": "Oracle-12vCPU-96GB-3Yrs-PartUpFront",
        "price": 2534.91,
        "softPrice": 3.47,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-1Yr-PartUpFront",
        "price": 2486.38,
        "softPrice": 3.41,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114412PU"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-NoUpFront",
        "price": 2207.77,
        "softPrice": 3.02,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3YrsNoUpFront",
        "price": 1116.2,
        "softPrice": 1.53,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 390.59,
        "softPrice": 0.54,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636PU"
    },
    {
        "name": "Oracle-8vCPU-64GB-3Yrs-PartUpFront",
        "price": 1756.61,
        "softPrice": 2.41,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106436PU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-PartUpFront",
        "price": 1594.54,
        "softPrice": 2.18,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-1Yr-UpFront",
        "price": 871.57,
        "softPrice": 1.19,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202012FU"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-PartUpFront",
        "price": 1139.61,
        "softPrice": 1.56,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212PU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-PartUpFront",
        "price": 642.96,
        "softPrice": 0.88,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036PU"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-UpFront",
        "price": 3048.77,
        "softPrice": 4.18,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412FU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-PartUpFront",
        "price": 2500.24,
        "softPrice": 3.42,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-NoUpFront",
        "price": 1716.6,
        "softPrice": 2.35,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-UpFront",
        "price": 872.38,
        "softPrice": 1.2,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812FU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 580.42,
        "softPrice": 0.8,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-NoUpFront",
        "price": 597.38,
        "softPrice": 0.82,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-1Yr-PartUpFront",
        "price": 2580.21,
        "softPrice": 3.53,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109612PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1186.44,
        "softPrice": 1.63,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836PU"
    },
    {
        "name": "HANA-10vCPU-80GB-3Yrs-PartUpFront",
        "price": 1401.4,
        "softPrice": 1.92,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108036PU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 657.29,
        "softPrice": 0.9,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103212PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-PartUpFront",
        "price": 1622,
        "softPrice": 2.22,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236PU"
    },
    {
        "name": "HANA-32vCPU-256GB-1Yr-PartUpFront",
        "price": 5518.5,
        "softPrice": 7.56,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125612PU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 1792.13,
        "softPrice": 2.45,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204812MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-PartUpFront",
        "price": 1248,
        "softPrice": 1.71,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-UpFront",
        "price": 1163.4,
        "softPrice": 1.59,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836FU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-On-Demand",
        "price": 2665.21,
        "softPrice": 2665.21,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111200MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-UpFront",
        "price": 2070.1,
        "softPrice": 2.84,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012FU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-PartUpFront",
        "price": 2136.77,
        "softPrice": 2.93,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012PU"
    },
    {
        "name": "Oracle-64vCPU-256GB-1Yr-NoUpFront",
        "price": 14999.46,
        "softPrice": 20.55,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125612MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-NoUpFront",
        "price": 2598.11,
        "softPrice": 3.56,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036MO"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-1Yr-UpFront",
        "price": 2435.01,
        "softPrice": 3.34,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110412FU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-3Yrs-NoUpFront",
        "price": 1209.47,
        "softPrice": 1.66,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104836MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-PartUpFront",
        "price": 1948.88,
        "softPrice": 2.67,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412PU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 2321.7,
        "softPrice": 3.18,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-PartUpFront",
        "price": 1414.51,
        "softPrice": 1.94,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436PU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-NoUpFront",
        "price": 2428.32,
        "softPrice": 3.33,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612MO"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 841.58,
        "softPrice": 1.15,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-PartUpFront",
        "price": 2150.18,
        "softPrice": 2.95,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012PU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-UpFront",
        "price": 1361.33,
        "softPrice": 1.86,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036FU"
    },
    {
        "name": "HANA-64vCPU-256GB-3Yrs-NoUpFront",
        "price": 6507.6,
        "softPrice": 8.91,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125636MO"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-UpFront",
        "price": 1338.04,
        "softPrice": 1.83,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612FU"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 845.52,
        "softPrice": 1.16,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203236MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-On-Demand",
        "price": 5375.62,
        "softPrice": 5375.62,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111200MO"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-3Yrs-PartUpFront",
        "price": 3559.31,
        "softPrice": 4.88,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114436PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-PartUpFront",
        "price": 4252.72,
        "softPrice": 5.83,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012PU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-NoUpFront",
        "price": 1485.95,
        "softPrice": 2.04,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212MO"
    },
    {
        "name": "Managed-Operating-System-Linux",
        "price": 250,
        "softPrice": 0,
        "SKU": "CLMCSOSYLNX00000MO"
    },
    {
        "name": "HANA-64vCPU-512GB-1Yr-NoUpFront",
        "price": 11134.4,
        "softPrice": 15.25,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151212MO"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-On-Demand",
        "price": 3839.73,
        "softPrice": 3839.73,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108000MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 669.85,
        "softPrice": 0.92,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612PU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-On-Demand",
        "price": 1535.89,
        "softPrice": 1535.89,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103200MO"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-On-Demand",
        "price": 4193.9,
        "softPrice": 4193.9,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114400MO"
    },
    {
        "name": "Oracle-16vCPU-128GB-1Yr-PartUpFront",
        "price": 4141.52,
        "softPrice": 5.67,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112812PU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 919.78,
        "softPrice": 1.26,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612MO"
    },
    {
        "name": "Oracle-6vCPU-48GB-3Yrs-PartUpFront",
        "price": 1367.46,
        "softPrice": 1.87,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104836PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 1324.66,
        "softPrice": 1.81,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812MO"
    },
    {
        "name": "HANA-40vCPU-160GB-1Yr-NoUpFront",
        "price": 5662.4,
        "softPrice": 7.76,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116012MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-NoUpFront",
        "price": 2414.67,
        "softPrice": 3.31,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212MO"
    },
    {
        "name": "Oracle-64vCPU-256GB-3Yrs-NoUpFront",
        "price": 12142.42,
        "softPrice": 16.63,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125636MO"
    },
    {
        "name": "MariaDB-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "WTOLMQKZ"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-3Yrs-PartUpFront",
        "price": 1562.37,
        "softPrice": 2.14,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206436PU"
    },
    {
        "name": "Managed-Microsoft-IIS",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCSWEBIIS00000MO"
    },
    {
        "name": "Oracle-32vCPU-128GB-1Yr-PartUpFront",
        "price": 7267.6,
        "softPrice": 9.96,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112812PU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-NoUpFront",
        "price": 2132.84,
        "softPrice": 2.92,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812MO"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-NoUpFront",
        "price": 2132.31,
        "softPrice": 2.92,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 216.54,
        "softPrice": 0.3,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100836PU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3Yrs-PartUpFront",
        "price": 2381.97,
        "softPrice": 3.26,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-PartUpFront",
        "price": 1631.48,
        "softPrice": 2.23,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612PU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-On-Demand",
        "price": 1725.92,
        "softPrice": 1725.92,
        "vcpu": "12",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104800MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-On-Demand",
        "price": 907.74,
        "softPrice": 907.74,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200800MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-1Yr-UpFront",
        "price": 1873.09,
        "softPrice": 2.57,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108012FU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 406.1,
        "softPrice": 0.56,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836PU"
    },
    {
        "name": "Mantis-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "OSMXZSBY"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 1268.28,
        "softPrice": 1.74,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-UpFront",
        "price": 635.29,
        "softPrice": 0.87,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836FU"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-3Yrs-NoUpFront",
        "price": 995.08,
        "softPrice": 1.36,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105636MO"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-NoUpFront",
        "price": 2225.96,
        "softPrice": 3.05,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-On-Demand",
        "price": 767.95,
        "softPrice": 767.95,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101600MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-On-Demand",
        "price": 1746.18,
        "softPrice": 1746.18,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203200MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-UpFront",
        "price": 3102.4,
        "softPrice": 4.25,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-3Yrs-PartUpFront",
        "price": 856.52,
        "softPrice": 1.17,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104036PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 315.47,
        "softPrice": 0.43,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-1Yr-UpFront",
        "price": 4152.26,
        "softPrice": 5.69,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112012FU"
    },
    {
        "name": "HANA-18vCPU-144GB-3Yrs-UpFront",
        "price": 2244,
        "softPrice": 3.07,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114436FU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3YrsNoUpFront",
        "price": 2678.88,
        "softPrice": 3.67,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636MO"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-UpFront",
        "price": 62.87,
        "softPrice": 0.09,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-UpFront",
        "price": 981.08,
        "softPrice": 1.34,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-1Yr-PartUpFront",
        "price": 141.76,
        "softPrice": 0.19,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100412PU"
    },
    {
        "name": "Managed-Firewall",
        "price": 250,
        "softPrice": 0,
        "SKU": "CLMCSNETFW000000MO"
    },
    {
        "name": "HANA-14vCPU-112GB-1Yr-UpFront",
        "price": 2357.6,
        "softPrice": 3.23,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111212FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 318.7,
        "softPrice": 0.44,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812PU"
    },
    {
        "name": "Oracle-4vCPU-16GB-3Yrs-PartUpFront",
        "price": 901.76,
        "softPrice": 1.24,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101636PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-1Yr-NoUpFront",
        "price": 770.43,
        "softPrice": 1.06,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201212MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-UpFront",
        "price": 1226.48,
        "softPrice": 1.68,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236FU"
    },
    {
        "name": "FwaaS-FortiNet-Advanced-XL",
        "price": 597.38,
        "softPrice": 4995.04,
        "SKU": "CLLICFORFWA0XL12MO"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-3Yrs-PartUpFront",
        "price": 1585.44,
        "softPrice": 2.17,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109636PU"
    },
    {
        "name": "Publify-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "JKEDXFYI"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-UpFront",
        "price": 1660.91,
        "softPrice": 2.28,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812FU"
    },
    {
        "name": "Jenkins-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "PQNNAJUX"
    },
    {
        "name": "Oracle-6vCPU-48GB-1Yr-PartUpFront",
        "price": 1709.32,
        "softPrice": 2.34,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104812PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-PartUpFront",
        "price": 503.74,
        "softPrice": 0.69,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-UpFront",
        "price": 371.27,
        "softPrice": 0.51,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-3Yrs-NoUpFront",
        "price": 1887.34,
        "softPrice": 2.59,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108036MO"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-UpFront",
        "price": 2861.47,
        "softPrice": 3.92,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612FU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-On-Demand",
        "price": 3878.74,
        "softPrice": 3878.74,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205200MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-PartUpFront",
        "price": 1785.93,
        "softPrice": 2.45,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 957.3,
        "softPrice": 1.31,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412MO"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-On-Demand",
        "price": 191.99,
        "softPrice": 191.99,
        "vcpu": "1",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100400MO"
    },
    {
        "name": "HANA-12vCPU-96GB-1Yr-UpFront",
        "price": 2070.6,
        "softPrice": 2.84,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109612FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 742.98,
        "softPrice": 1.02,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612MO"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 761.43,
        "softPrice": 1.04,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106436FU"
    },
    {
        "name": "ECS-1vCPU-4GB-WIN-3YrsNoUpFront",
        "price": 111.62,
        "softPrice": 0.15,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100436MO"
    },
    {
        "name": "HANA-32vCPU-256GB-3Yrs-NoUpFront",
        "price": 4414.8,
        "softPrice": 6.05,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125636MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-UpFront",
        "price": 442.71,
        "softPrice": 0.61,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-PartUpFront",
        "price": 378.75,
        "softPrice": 0.52,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212PU"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-PartUpFront",
        "price": 1851.87,
        "softPrice": 2.54,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212PU"
    },
    {
        "name": "E-Mail-Security-Service",
        "price": 7,
        "softPrice": 0,
        "SKU": "CLSASSECEMLESS00MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 921.96,
        "softPrice": 1.26,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236FU"
    },
    {
        "name": "HANA-16vCPU-128GB-3Yrs-PartUpFront",
        "price": 2077.9,
        "softPrice": 2.85,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112836PU"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-On-Demand",
        "price": 3225.26,
        "softPrice": 3225.26,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109600MO"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-1Yr-UpFront",
        "price": 1962.15,
        "softPrice": 2.69,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205612FU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-NoUpFront",
        "price": 1056.9,
        "softPrice": 1.45,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 1772.44,
        "softPrice": 2.43,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-1Yr-NoUpFront",
        "price": 2205.84,
        "softPrice": 3.02,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204012MO"
    },
    {
        "name": "Oracle-40vCPU-160GB-3Yrs-UpFront",
        "price": 6766.5,
        "softPrice": 9.27,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116036FU"
    },
    {
        "name": "AVI-LbaaS-2vCPU-8GB",
        "price": 310,
        "softPrice": 3214.29,
        "SKU": "CLLICVMWLBN00M00MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-1Yr-UpFront",
        "price": 560.61,
        "softPrice": 0.77,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201612FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 742.55,
        "softPrice": 1.02,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836FU"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-PartUpFront",
        "price": 2657.57,
        "softPrice": 3.64,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012PU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-3Yrs-PartUpFront",
        "price": 64.3,
        "softPrice": 0.09,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200236PU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-PartUpFront",
        "price": 1717.55,
        "softPrice": 2.35,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436PU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3YrsNoUpFront",
        "price": 446.48,
        "softPrice": 0.61,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-NoUpFront",
        "price": 1311.88,
        "softPrice": 1.8,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-3Yrs-UpFront",
        "price": 1174.35,
        "softPrice": 1.61,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-NoUpFront",
        "price": 441.55,
        "softPrice": 0.6,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612MO"
    },
    {
        "name": "HANA-8vCPU-64GB-3Yrs-NoUpFront",
        "price": 1282.8,
        "softPrice": 1.76,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106436MO"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-On-Demand",
        "price": 3819.09,
        "softPrice": 3819.09,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108000MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-PartUpFront",
        "price": 1321.2,
        "softPrice": 1.81,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036PU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-On-Demand",
        "price": 3071.78,
        "softPrice": 3071.78,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106400MO"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-On-Demand",
        "price": 2443.25,
        "softPrice": 2443.25,
        "vcpu": "18",
        "ram": "36",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203600MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-NoUpFront",
        "price": 1675.27,
        "softPrice": 2.29,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212MO"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3Yrs-PartUpFront",
        "price": 3248.14,
        "softPrice": 4.45,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-On-Demand",
        "price": 4991.65,
        "softPrice": 4991.65,
        "vcpu": "26",
        "ram": "104",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110400MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-On-Demand",
        "price": 3762.81,
        "softPrice": 3762.81,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111200MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 779.42,
        "softPrice": 1.07,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-1Yr-UpFront",
        "price": 2092.58,
        "softPrice": 2.87,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108012FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-On-Demand",
        "price": 2727.78,
        "softPrice": 2727.78,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106400MO"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-UpFront",
        "price": 1766.85,
        "softPrice": 2.42,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836FU"
    },
    {
        "name": "Oracle-12vCPU-96GB-3Yrs-UpFront",
        "price": 2376.48,
        "softPrice": 3.26,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109636FU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-On-Demand",
        "price": 287.65,
        "softPrice": 287.65,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100800MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3Yrs-UpFront",
        "price": 1484.55,
        "softPrice": 2.03,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636FU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-NoUpFront",
        "price": 1184.25,
        "softPrice": 1.62,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636MO"
    },
    {
        "name": "HANA-18vCPU-144GB-On-Demand",
        "price": 4936.8,
        "softPrice": 4936.8,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0114400MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-3Yrs-PartUpFront",
        "price": 1464.72,
        "softPrice": 2.01,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206036PU"
    },
    {
        "name": "HANA-12vCPU-96GB-1Yr-PartUpFront",
        "price": 2218.5,
        "softPrice": 3.04,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109612PU"
    },
    {
        "name": "Oracle-32vCPU-256GB-1Yr-PartUpFront",
        "price": 8033.04,
        "softPrice": 11,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125612PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-UpFront",
        "price": 4429.08,
        "softPrice": 6.07,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812FU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-1Yr-NoUpFront",
        "price": 397.07,
        "softPrice": 0.54,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200212MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-UpFront",
        "price": 618.79,
        "softPrice": 0.85,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036FU"
    },
    {
        "name": "Oracle-8vCPU-64GB-On-Demand",
        "price": 2634.91,
        "softPrice": 2634.91,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106400MO"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 477.53,
        "softPrice": 0.65,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812PU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-3Yrs-PartUpFront",
        "price": 683.54,
        "softPrice": 0.94,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202836PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-On-Demand",
        "price": 3455.76,
        "softPrice": 3455.76,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107200MO"
    },
    {
        "name": "Oracle-64vCPU-512GB-1Yr-UpFront",
        "price": 15025.28,
        "softPrice": 20.58,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151212FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-On-Demand",
        "price": 1289.52,
        "softPrice": 1289.52,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102400MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-PartUpFront",
        "price": 2768.35,
        "softPrice": 3.79,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236PU"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-PartUpFront",
        "price": 396.36,
        "softPrice": 0.54,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436PU"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-3Yrs-NoUpFront",
        "price": 967.99,
        "softPrice": 1.33,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202836MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-On-Demand",
        "price": 3660.46,
        "softPrice": 3660.46,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204800MO"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-NoUpFront",
        "price": 1300.21,
        "softPrice": 1.78,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-On-Demand",
        "price": 814.42,
        "softPrice": 814.42,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201200MO"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-NoUpFront",
        "price": 525.8,
        "softPrice": 0.72,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-On-Demand",
        "price": 2217.38,
        "softPrice": 2217.38,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203200MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-PartUpFront",
        "price": 961.63,
        "softPrice": 1.32,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-3Yrs-UpFront",
        "price": 310.03,
        "softPrice": 0.42,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103236FU"
    },
    {
        "name": "Directory-Sync-Tool",
        "price": 1.74,
        "softPrice": 0,
        "SKU": "CLSASACDSYN00000MO"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 290.21,
        "softPrice": 0.4,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-PartUpFront",
        "price": 528.48,
        "softPrice": 0.72,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236PU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 877.32,
        "softPrice": 1.2,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201612PU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-On-Demand",
        "price": 1151.92,
        "softPrice": 1151.92,
        "vcpu": "6",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102400MO"
    },
    {
        "name": "Oracle-6vCPU-48GB-3Yrs-NoUpFront",
        "price": 1452.92,
        "softPrice": 1.99,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104836MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-On-Demand",
        "price": 3529.14,
        "softPrice": 3529.14,
        "vcpu": "26",
        "ram": "52",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205200MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-PartUpFront",
        "price": 850.54,
        "softPrice": 1.17,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412PU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-UpFront",
        "price": 1107.27,
        "softPrice": 1.52,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212FU"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-1Yr-UpFront",
        "price": 522.94,
        "softPrice": 0.72,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201212FU"
    },
    {
        "name": "ECS-18vCPU-36GB-WIN-1Yr-UpFront",
        "price": 1568.82,
        "softPrice": 2.15,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203612FU"
    },
    {
        "name": "FwaaS-FortiNet-Basic-XXL",
        "price": 1194.75,
        "softPrice": 8342.58,
        "SKU": "CLLICFORFWBXXL12MO"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-1Yr-UpFront",
        "price": 280.31,
        "softPrice": 0.38,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200812FU"
    },
    {
        "name": "Oracle-4vCPU-32GB-3Yrs-NoUpFront",
        "price": 1039.45,
        "softPrice": 1.42,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103236MO"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-NoUpFront",
        "price": 2889.04,
        "softPrice": 3.96,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812MO"
    },
    {
        "name": "Oracle-40vCPU-160GB-On-Demand",
        "price": 10826.4,
        "softPrice": 10826.4,
        "vcpu": "40",
        "ram": "160",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116000MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-UpFront",
        "price": 1886.02,
        "softPrice": 2.58,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036FU"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-1Yr-UpFront",
        "price": 3236.08,
        "softPrice": 4.43,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111212FU"
    },
    {
        "name": "HANA-16vCPU-128GB-1Yr-PartUpFront",
        "price": 2833.5,
        "softPrice": 3.88,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112812PU"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-3Yrs-UpFront",
        "price": 1237.58,
        "softPrice": 1.7,
        "vcpu": "20",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108036FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-1Yr-PartUpFront",
        "price": 2307.91,
        "softPrice": 3.16,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109612PU"
    },
    {
        "name": "ECS-18vCPU-72GB-WIN-1Yr-NoUpFront",
        "price": 2611.91,
        "softPrice": 3.58,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0107212MO"
    },
    {
        "name": "DETASAD-Cloud-DR-Service-SER",
        "price": 195,
        "softPrice": 0,
        "SKU": "CLDRSDTS0PM00000MO"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-NoUpFront",
        "price": 1199.34,
        "softPrice": 1.64,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236MO"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-3Yrs-PartUpFront",
        "price": 3163.83,
        "softPrice": 4.33,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112836PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-NoUpFront",
        "price": 896.06,
        "softPrice": 1.23,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-PartUpFront",
        "price": 1063.03,
        "softPrice": 1.46,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412PU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-UpFront",
        "price": 2630.71,
        "softPrice": 3.6,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-On-Demand",
        "price": 575.31,
        "softPrice": 575.31,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101600MO"
    },
    {
        "name": "Managed-MS-SharePoint",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCS0MSSHP00000MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-NoUpFront",
        "price": 1745.19,
        "softPrice": 2.39,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236MO"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-3Yrs-NoUpFront",
        "price": 426.46,
        "softPrice": 0.58,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102436MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-PartUpFront",
        "price": 1120.76,
        "softPrice": 1.54,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636PU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-1Yr-NoUpFront",
        "price": 471.74,
        "softPrice": 0.65,
        "vcpu": "2",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200412MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 459.31,
        "softPrice": 0.63,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236PU"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-On-Demand",
        "price": 3012.41,
        "softPrice": 3012.41,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111200MO"
    },
    {
        "name": "ECS-28vCPU-112GB-Linux-On-Demand",
        "price": 4027.14,
        "softPrice": 4027.14,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0111200MO"
    },
    {
        "name": "Oracle-14vCPU-112GB-On-Demand",
        "price": 4386.1,
        "softPrice": 4386.1,
        "vcpu": "14",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111200MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-NoUpFront",
        "price": 1941.47,
        "softPrice": 2.66,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212MO"
    },
    {
        "name": "Oracle-10vCPU-40GB-3Yrs-PartUpFront",
        "price": 1954.4,
        "softPrice": 2.68,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104036PU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-UpFront",
        "price": 187.31,
        "softPrice": 0.26,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812FU"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-UpFront",
        "price": 1764.41,
        "softPrice": 2.42,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212FU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-UpFront",
        "price": 3348.13,
        "softPrice": 4.59,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812FU"
    },
    {
        "name": "ECS-18vCPU-144GB-RedHat-3Yrs-NoUpFront",
        "price": 1887.25,
        "softPrice": 2.59,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0114436MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-PartUpFront",
        "price": 2282.59,
        "softPrice": 3.13,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236PU"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-UpFront",
        "price": 241.3,
        "softPrice": 0.33,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236FU"
    },
    {
        "name": "HANA-32vCPU-256GB-1Yr-UpFront",
        "price": 5150.6,
        "softPrice": 7.06,
        "vcpu": "32",
        "ram": "256",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125612FU"
    },
    {
        "name": "Oracle-10vCPU-40GB-On-Demand",
        "price": 2931.6,
        "softPrice": 2931.6,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104000MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 606.41,
        "softPrice": 0.83,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836FU"
    },
    {
        "name": "ECS-28vCPU-56GB-WIN-1Yr-NoUpFront",
        "price": 2600.42,
        "softPrice": 3.56,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 717.97,
        "softPrice": 0.98,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812MO"
    },
    {
        "name": "HANA-40vCPU-160GB-3Yrs-NoUpFront",
        "price": 4246.8,
        "softPrice": 5.82,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116036MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-UpFront",
        "price": 3610.7,
        "softPrice": 4.95,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3Yrs-UpFront",
        "price": 2332.86,
        "softPrice": 3.2,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836FU"
    },
    {
        "name": "MySQL-Master-Slave",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBMYS0MS00MO"
    },
    {
        "name": "HANA-40vCPU-160GB-3Yrs-PartUpFront",
        "price": 3892.9,
        "softPrice": 5.33,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116036PU"
    },
    {
        "name": "ECS-28vCPU-56GB-Linux-On-Demand",
        "price": 3055.81,
        "softPrice": 3055.81,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205600MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-On-Demand",
        "price": 1999.1,
        "softPrice": 1999.1,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202800MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 1109.52,
        "softPrice": 1.52,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212MO"
    },
    {
        "name": "DETASAD-Cloud-Migration-Service-SER",
        "price": 1492.5,
        "softPrice": 0,
        "SKU": "CLMGSDTS0PM00000MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 460.16,
        "softPrice": 0.63,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101636PU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-1Yr-PartUpFront",
        "price": 283.51,
        "softPrice": 0.39,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100812PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-3Yrs-PartUpFront",
        "price": 1515.8,
        "softPrice": 2.08,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105636PU"
    },
    {
        "name": "Oracle-4vCPU-32GB-3Yrs-PartUpFront",
        "price": 978.3,
        "softPrice": 1.34,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103236PU"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-UpFront",
        "price": 678.55,
        "softPrice": 0.93,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-3Yrs-NoUpFront",
        "price": 528.45,
        "softPrice": 0.72,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202036MO"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-On-Demand",
        "price": 2714.72,
        "softPrice": 2714.72,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204000MO"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-3Yrs-NoUpFront",
        "price": 568.62,
        "softPrice": 0.78,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103236MO"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-UpFront",
        "price": 1115.04,
        "softPrice": 1.53,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012FU"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 2388.93,
        "softPrice": 3.27,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204812PU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 241.91,
        "softPrice": 0.33,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836MO"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-PartUpFront",
        "price": 3118.66,
        "softPrice": 4.27,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-1Yr-UpFront",
        "price": 1588.92,
        "softPrice": 2.18,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105612FU"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-On-Demand",
        "price": 1438.26,
        "softPrice": 1438.26,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104000MO"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-On-Demand",
        "price": 4533.55,
        "softPrice": 4533.55,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206400MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-UpFront",
        "price": 1937.72,
        "softPrice": 2.65,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612FU"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-UpFront",
        "price": 2768.18,
        "softPrice": 3.79,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012FU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-3YrsNoUpFront",
        "price": 3348.6,
        "softPrice": 4.59,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112036MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-1Yr-UpFront",
        "price": 1822,
        "softPrice": 2.5,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205212FU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-UpFront",
        "price": 1257.34,
        "softPrice": 1.72,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036FU"
    },
    {
        "name": "Oracle-64vCPU-512GB-3Yrs-UpFront",
        "price": 11862.06,
        "softPrice": 16.25,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151236FU"
    },
    {
        "name": "FWaaS-FortiNet-UTM-Medium",
        "price": 149.34,
        "softPrice": 1012.4,
        "SKU": "CLLICFORFWU00M12MO"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-NoUpFront",
        "price": 650.92,
        "softPrice": 0.89,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-1Yr-UpFront",
        "price": 1318.4,
        "softPrice": 1.81,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108012FU"
    },
    {
        "name": "Oracle-2vCPU-16GB-3Yrs-UpFront",
        "price": 552.33,
        "softPrice": 0.76,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101636FU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-PartUpFront",
        "price": 4536.24,
        "softPrice": 6.21,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812PU"
    },
    {
        "name": "HANA-10vCPU-80GB-1Yr-UpFront",
        "price": 1783.6,
        "softPrice": 2.44,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108012FU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-UpFront",
        "price": 1917.45,
        "softPrice": 2.63,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-NoUpFront",
        "price": 201.58,
        "softPrice": 0.28,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 1423.79,
        "softPrice": 1.95,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212FU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-UpFront",
        "price": 223.01,
        "softPrice": 0.31,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-UpFront",
        "price": 740.45,
        "softPrice": 1.01,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-PartUpFront",
        "price": 2113.91,
        "softPrice": 2.9,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836PU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-UpFront",
        "price": 245.4,
        "softPrice": 0.34,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436FU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-1Yr-UpFront",
        "price": 1685.78,
        "softPrice": 2.31,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107212FU"
    },
    {
        "name": "Windows-Server-Datacenter-Core-2-Core",
        "price": 171.27,
        "softPrice": 0,
        "SKU": "CLLICMS0WINENT00MO"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-3Yrs-NoUpFront",
        "price": 1708.84,
        "softPrice": 2.34,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205236MO"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-On-Demand",
        "price": 2687.81,
        "softPrice": 2687.81,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105600MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-1Yr-UpFront",
        "price": 1027,
        "softPrice": 1.41,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103212FU"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-1Yr-NoUpFront",
        "price": 1114.46,
        "softPrice": 1.53,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202412MO"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-1Yr-NoUpFront",
        "price": 1893.51,
        "softPrice": 2.59,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111212MO"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-PartUpFront",
        "price": 1771.71,
        "softPrice": 2.43,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012PU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-NoUpFront",
        "price": 1918.96,
        "softPrice": 2.63,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412MO"
    },
    {
        "name": "Managed-Skype-for-Business",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCS0MSSFB00000MO"
    },
    {
        "name": "Oracle-2vCPU-16GB-3Yrs-PartUpFront",
        "price": 589.15,
        "softPrice": 0.81,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101636PU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 1720.14,
        "softPrice": 2.36,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106412PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-PartUpFront",
        "price": 854.71,
        "softPrice": 1.17,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412PU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-NoUpFront",
        "price": 1214.16,
        "softPrice": 1.66,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812MO"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-UpFront",
        "price": 1612.74,
        "softPrice": 2.21,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236FU"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-1Yr-NoUpFront",
        "price": 337.9,
        "softPrice": 0.46,
        "vcpu": "1",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100812MO"
    },
    {
        "name": "Oracle-2vCPU-16GB-1Yr-NoUpFront",
        "price": 773.26,
        "softPrice": 1.06,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101612MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-PartUpFront",
        "price": 771.55,
        "softPrice": 1.06,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436PU"
    },
    {
        "name": "ECS-8vCPU-64GB-WIN-3Yrs-PartUpFront",
        "price": 1581.92,
        "softPrice": 2.17,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0106436PU"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-1Yr-UpFront",
        "price": 669.02,
        "softPrice": 0.92,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104812FU"
    },
    {
        "name": "MS-Exchange-Server-Std",
        "price": 11.73,
        "softPrice": 0,
        "SKU": "CLLICMS0EXCSTD00MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-1Yr-UpFront",
        "price": 936.54,
        "softPrice": 1.28,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104012FU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-NoUpFront",
        "price": 4062.97,
        "softPrice": 5.57,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-NoUpFront",
        "price": 333.85,
        "softPrice": 0.46,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436MO"
    },
    {
        "name": "Oracle-2vCPU-16GB-On-Demand",
        "price": 883.73,
        "softPrice": 883.73,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0101600MO"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-3Yrs-UpFront",
        "price": 1519.34,
        "softPrice": 2.08,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107236FU"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-1Yr-UpFront",
        "price": 420.46,
        "softPrice": 0.58,
        "vcpu": "6",
        "ram": "12",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201212FU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-3Yrs-NoUpFront",
        "price": 1563.69,
        "softPrice": 2.14,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108836MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-1Yr-UpFront",
        "price": 1487.51,
        "softPrice": 2.04,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102412FU"
    },
    {
        "name": "Email-ATP",
        "price": 7,
        "softPrice": 0,
        "SKU": "CLSASSECEMLATP00MO"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-1Yr-NoUpFront",
        "price": 1045.41,
        "softPrice": 1.43,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202812MO"
    },
    {
        "name": "HANA-12vCPU-96GB-On-Demand",
        "price": 3253.8,
        "softPrice": 3253.8,
        "vcpu": "12",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109600MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3Yrs-PartUpFront",
        "price": 649.63,
        "softPrice": 0.89,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436PU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-3Yrs-NoUpFront",
        "price": 1983.81,
        "softPrice": 2.72,
        "vcpu": "28",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205636MO"
    },
    {
        "name": "Oracle-4vCPU-16GB-On-Demand",
        "price": 1352.64,
        "softPrice": 1352.64,
        "vcpu": "4",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101600MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-3Yrs-UpFront",
        "price": 1383.08,
        "softPrice": 1.89,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204436FU"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 1089.06,
        "softPrice": 1.49,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204836FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 395.48,
        "softPrice": 0.54,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636PU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-PartUpFront",
        "price": 1566.96,
        "softPrice": 2.15,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412PU"
    },
    {
        "name": "HANA-8vCPU-64GB-On-Demand",
        "price": 2351.8,
        "softPrice": 2351.8,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106400MO"
    },
    {
        "name": "FwaaS-FortiNet-Basic-Medium",
        "price": 149.34,
        "softPrice": 683.07,
        "SKU": "CLLICFORFWB00M12MO"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-NoUpFront",
        "price": 371.49,
        "softPrice": 0.51,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-On-Demand",
        "price": 3426.7,
        "softPrice": 3426.7,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114400MO"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-NoUpFront",
        "price": 2240.16,
        "softPrice": 3.07,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-NoUpFront",
        "price": 670.24,
        "softPrice": 0.92,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836MO"
    },
    {
        "name": "Oracle-32vCPU-128GB-On-Demand",
        "price": 8721.12,
        "softPrice": 8721.12,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112800MO"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-1Yr-UpFront",
        "price": 348.63,
        "softPrice": 0.48,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200812FU"
    },
    {
        "name": "HANA-64vCPU-512GB-1Yr-PartUpFront",
        "price": 10438.5,
        "softPrice": 14.3,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151212PU"
    },
    {
        "name": "ECS-1vCPU-4GB-RedHat-3Yrs-PartUpFront",
        "price": 261.98,
        "softPrice": 0.36,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100436PU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-UpFront",
        "price": 193.9,
        "softPrice": 0.27,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836FU"
    },
    {
        "name": "HANA-64vCPU-256GB-1Yr-UpFront",
        "price": 7592.2,
        "softPrice": 10.4,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125612FU"
    },
    {
        "name": "PostgreSQL-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "HVGIGUTS"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 387.8,
        "softPrice": 0.53,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636FU"
    },
    {
        "name": "HANA-64vCPU-256GB-On-Demand",
        "price": 11930.6,
        "softPrice": 11930.6,
        "vcpu": "64",
        "ram": "256",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125600MO"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-3Yrs-PartUpFront",
        "price": 1285.92,
        "softPrice": 1.76,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204036PU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-NoUpFront",
        "price": 1069.12,
        "softPrice": 1.46,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012MO"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-UpFront",
        "price": 558.94,
        "softPrice": 0.77,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636FU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-UpFront",
        "price": 1784.06,
        "softPrice": 2.44,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812FU"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-1Yr-UpFront",
        "price": 830.45,
        "softPrice": 1.14,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102412FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-On-Demand",
        "price": 714.21,
        "softPrice": 714.21,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100800MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-UpFront",
        "price": 2714.6,
        "softPrice": 3.72,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236FU"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 2268.12,
        "softPrice": 3.11,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412PU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-1Yr-PartUpFront",
        "price": 2745.79,
        "softPrice": 3.76,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108812PU"
    },
    {
        "name": "FwaaS-FortiNet-Advanced-Medium",
        "price": 149.34,
        "softPrice": 866.03,
        "SKU": "CLLICFORFWA00M12MO"
    },
    {
        "name": "ECS-12vCPU-24GB-WIN-3Yrs-UpFront",
        "price": 754.41,
        "softPrice": 1.03,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202436FU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-1Yr-UpFront",
        "price": 465.07,
        "softPrice": 0.64,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100812FU"
    },
    {
        "name": "HANA-10vCPU-80GB-1Yr-NoUpFront",
        "price": 2038.4,
        "softPrice": 2.79,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108012MO"
    },
    {
        "name": "Oracle-64vCPU-512GB-3Yrs-PartUpFront",
        "price": 12652.86,
        "softPrice": 17.33,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151236PU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 708.68,
        "softPrice": 0.97,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612PU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3Yrs-UpFront",
        "price": 1060.39,
        "softPrice": 1.45,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036FU"
    },
    {
        "name": "ECS-20vCPU-40GB-WIN-1Yr-NoUpFront",
        "price": 1857.44,
        "softPrice": 2.54,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204012MO"
    },
    {
        "name": "Oracle-12vCPU-48GB-3Yrs-NoUpFront",
        "price": 2449.36,
        "softPrice": 3.36,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104836MO"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 617.05,
        "softPrice": 0.85,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104836PU"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 1637.58,
        "softPrice": 2.24,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-3Yrs-PartUpFront",
        "price": 788.68,
        "softPrice": 1.08,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108036PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-On-Demand",
        "price": 1522.98,
        "softPrice": 1522.98,
        "vcpu": "8",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106400MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-NoUpFront",
        "price": 806.32,
        "softPrice": 1.1,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-On-Demand",
        "price": 271.47,
        "softPrice": 271.47,
        "vcpu": "2",
        "ram": "4",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200400MO"
    },
    {
        "name": "CentOS",
        "price": 0,
        "softPrice": 0,
        "SKU": "YWGXYRIS"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-PartUpFront",
        "price": 1269.42,
        "softPrice": 1.74,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236PU"
    },
    {
        "name": "Kafka-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "TDINQKGK"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3YrsNoUpFront",
        "price": 669.72,
        "softPrice": 0.92,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436MO"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-3Yrs-NoUpFront",
        "price": 498.91,
        "softPrice": 0.68,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103236MO"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 775.6,
        "softPrice": 1.06,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103236FU"
    },
    {
        "name": "Oracle-14vCPU-112GB-3Yrs-UpFront",
        "price": 2741.31,
        "softPrice": 3.76,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111236FU"
    },
    {
        "name": "ECS-14vCPU-28GB-Linux-On-Demand",
        "price": 1527.9,
        "softPrice": 1527.9,
        "vcpu": "14",
        "ram": "28",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202800MO"
    },
    {
        "name": "HANA-14vCPU-112GB-3Yrs-PartUpFront",
        "price": 1852.4,
        "softPrice": 2.54,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111236PU"
    },
    {
        "name": "Trend-Micro-End-Point-Protection-VM",
        "price": 89.42,
        "softPrice": 0,
        "SKU": "CLLICTRMEPP00000MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-UpFront",
        "price": 2091.76,
        "softPrice": 2.87,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812FU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-1Yr-NoUpFront",
        "price": 1196.62,
        "softPrice": 1.64,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108012MO"
    },
    {
        "name": "Oracle-32vCPU-128GB-3Yrs-UpFront",
        "price": 5450.7,
        "softPrice": 7.47,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112836FU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-3Yrs-PartUpFront",
        "price": 1082.71,
        "softPrice": 1.48,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104036PU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 1417.37,
        "softPrice": 1.94,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212PU"
    },
    {
        "name": "Oracle-12vCPU-96GB-1Yr-UpFront",
        "price": 3010.21,
        "softPrice": 4.12,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109612FU"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-NoUpFront",
        "price": 920.15,
        "softPrice": 1.26,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836MO"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-NoUpFront",
        "price": 3035.41,
        "softPrice": 4.16,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012MO"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-UpFront",
        "price": 544.53,
        "softPrice": 0.75,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436FU"
    },
    {
        "name": "Oracle-32vCPU-256GB-3Yrs-UpFront",
        "price": 6024.78,
        "softPrice": 8.25,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125636FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-NoUpFront",
        "price": 1348.03,
        "softPrice": 1.85,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-PartUpFront",
        "price": 2150.47,
        "softPrice": 2.95,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436PU"
    },
    {
        "name": "ECS-22vCPU-88GB-Linux-1Yr-PartUpFront",
        "price": 2115.59,
        "softPrice": 2.9,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108812PU"
    },
    {
        "name": "Managed-Active-Directory",
        "price": 350,
        "softPrice": 0,
        "SKU": "CLMCS0MSACD00000MO"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-3Yrs-PartUpFront",
        "price": 259.62,
        "softPrice": 0.36,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200236PU"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-1Yr-PartUpFront",
        "price": 192.33,
        "softPrice": 0.26,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100812PU"
    },
    {
        "name": "Oracle-8vCPU-64GB-1Yr-PartUpFront",
        "price": 2195.76,
        "softPrice": 3.01,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106412PU"
    },
    {
        "name": "ECS-8vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 1095.39,
        "softPrice": 1.5,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0106412FU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 424.16,
        "softPrice": 0.58,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636FU"
    },
    {
        "name": "ECS-10vCPU-20GB-WIN-3Yrs-UpFront",
        "price": 628.67,
        "softPrice": 0.86,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202036FU"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-1Yr-NoUpFront",
        "price": 1435.95,
        "softPrice": 1.97,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109612MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-On-Demand",
        "price": 1142.23,
        "softPrice": 1142.23,
        "vcpu": "6",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104800MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-On-Demand",
        "price": 5257.35,
        "softPrice": 5257.35,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112000MO"
    },
    {
        "name": "Oracle-10vCPU-40GB-1Yr-UpFront",
        "price": 2320.85,
        "softPrice": 3.18,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104012FU"
    },
    {
        "name": "Oracle-32vCPU-128GB-3Yrs-PartUpFront",
        "price": 5814.08,
        "softPrice": 7.96,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112836PU"
    },
    {
        "name": "AVI-LbaaS-1vCPU-4GB",
        "price": 166,
        "softPrice": 1607.14,
        "SKU": "CLLICVMWLBN00S00MO"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-1Yr-NoUpFront",
        "price": 3772.76,
        "softPrice": 5.17,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110412MO"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-NoUpFront",
        "price": 1642.78,
        "softPrice": 2.25,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-3Yrs-UpFront",
        "price": 1173.58,
        "softPrice": 1.61,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106436FU"
    },
    {
        "name": "phpBB-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "PUCWNEDB"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-1Yr-PartUpFront",
        "price": 1805.81,
        "softPrice": 2.47,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112812PU"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-NoUpFront",
        "price": 85.67,
        "softPrice": 0.12,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836MO"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-UpFront",
        "price": 1929.94,
        "softPrice": 2.64,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612FU"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-NoUpFront",
        "price": 317.07,
        "softPrice": 0.43,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236MO"
    },
    {
        "name": "ECS-2vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 132.12,
        "softPrice": 0.18,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100836PU"
    },
    {
        "name": "ECS-10vCPU-80GB-WIN-3Yrs-NoUpFront",
        "price": 2015.79,
        "softPrice": 2.76,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0108036MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 77.51,
        "softPrice": 0.11,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836FU"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-UpFront",
        "price": 286.68,
        "softPrice": 0.39,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-On-Demand",
        "price": 4343.55,
        "softPrice": 4343.55,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206400MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-NoUpFront",
        "price": 1012.91,
        "softPrice": 1.39,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036MO"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-UpFront",
        "price": 2242.46,
        "softPrice": 3.07,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412FU"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-UpFront",
        "price": 2929.61,
        "softPrice": 4.01,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212FU"
    },
    {
        "name": "Oracle-10vCPU-80GB-1Yr-PartUpFront",
        "price": 2682.2,
        "softPrice": 3.67,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108012PU"
    },
    {
        "name": "ECS-14vCPU-56GB-WIN-1Yr-NoUpFront",
        "price": 2031.48,
        "softPrice": 2.78,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0105612MO"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-PartUpFront",
        "price": 792.72,
        "softPrice": 1.09,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836PU"
    },
    {
        "name": "Cassandra-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "YCFHWPTX"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-3Yrs-UpFront",
        "price": 1249.72,
        "softPrice": 1.71,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203636FU"
    },
    {
        "name": "HANA-14vCPU-112GB-1Yr-PartUpFront",
        "price": 2526,
        "softPrice": 3.46,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0111212PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-3Yrs-PartUpFront",
        "price": 585.89,
        "softPrice": 0.8,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202436PU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 384.65,
        "softPrice": 0.53,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101612PU"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-On-Demand",
        "price": 2986.19,
        "softPrice": 2986.19,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204400MO"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3Yrs-PartUpFront",
        "price": 2815.06,
        "softPrice": 3.86,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436PU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-3Yrs-UpFront",
        "price": 502.94,
        "softPrice": 0.69,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201636FU"
    },
    {
        "name": "ECS-20vCPU-80GB-RedHat-1Yr-PartUpFront",
        "price": 2553.46,
        "softPrice": 3.5,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108012PU"
    },
    {
        "name": "ECS-10vCPU-80GB-Linux-On-Demand",
        "price": 1903.72,
        "softPrice": 1903.72,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0108000MO"
    },
    {
        "name": "ECS-20vCPU-40GB-RedHat-3Yrs-UpFront",
        "price": 1340.47,
        "softPrice": 1.84,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204036FU"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-On-Demand",
        "price": 2250.92,
        "softPrice": 2250.92,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108000MO"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-On-Demand",
        "price": 1919.86,
        "softPrice": 1919.86,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104000MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-UpFront",
        "price": 3423.39,
        "softPrice": 4.69,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012FU"
    },
    {
        "name": "ECS-8vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 1134.06,
        "softPrice": 1.55,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0103212PU"
    },
    {
        "name": "Oracle-16vCPU-128GB-1Yr-NoUpFront",
        "price": 4348.6,
        "softPrice": 5.96,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112812MO"
    },
    {
        "name": "ECS-26vCPU-52GB-Linux-3Yrs-UpFront",
        "price": 1179.82,
        "softPrice": 1.62,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0205236FU"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-PartUpFront",
        "price": 1823.81,
        "softPrice": 2.5,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412PU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 2279.22,
        "softPrice": 3.12,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412PU"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-On-Demand",
        "price": 1126.02,
        "softPrice": 1126.02,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201200MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-1Yr-NoUpFront",
        "price": 4643.39,
        "softPrice": 6.36,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112812MO"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-NoUpFront",
        "price": 545.23,
        "softPrice": 0.75,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236MO"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-3Yrs-NoUpFront",
        "price": 71.08,
        "softPrice": 0.1,
        "vcpu": "1",
        "ram": "4",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100436MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-PartUpFront",
        "price": 3130.44,
        "softPrice": 4.29,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412PU"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-On-Demand",
        "price": 1075.09,
        "softPrice": 1075.09,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103200MO"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-On-Demand",
        "price": 3393.15,
        "softPrice": 3393.15,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112800MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-PartUpFront",
        "price": 932.52,
        "softPrice": 1.28,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036PU"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-3Yrs-UpFront",
        "price": 880.14,
        "softPrice": 1.21,
        "vcpu": "14",
        "ram": "28",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202836FU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-PartUpFront",
        "price": 1028.74,
        "softPrice": 1.41,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236PU"
    },
    {
        "name": "Oracle-10vCPU-80GB-1Yr-UpFront",
        "price": 2548.09,
        "softPrice": 3.49,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108012FU"
    },
    {
        "name": "FWaaS-FortiNet-UTM-Small",
        "price": 74.67,
        "softPrice": 906.76,
        "SKU": "CLLICFORFWU00S12MO"
    },
    {
        "name": "Oracle-8vCPU-32GB-1Yr-NoUpFront",
        "price": 2104.62,
        "softPrice": 2.88,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103212MO"
    },
    {
        "name": "Oracle-16vCPU-64GB-3Yrs-PartUpFront",
        "price": 3007.04,
        "softPrice": 4.12,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106436PU"
    },
    {
        "name": "Oracle-14vCPU-112GB-3Yrs-PartUpFront",
        "price": 2924.06,
        "softPrice": 4.01,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111236PU"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-On-Demand",
        "price": 3492.35,
        "softPrice": 3492.35,
        "vcpu": "32",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206400MO"
    },
    {
        "name": "ECS-16vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 1776.23,
        "softPrice": 2.43,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0106412FU"
    },
    {
        "name": "MS-SQL-Always-On",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBSQLALO00MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-NoUpFront",
        "price": 3900.85,
        "softPrice": 5.34,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812MO"
    },
    {
        "name": "Oracle-16vCPU-128GB-On-Demand",
        "price": 4969.82,
        "softPrice": 4969.82,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112800MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-PartUpFront",
        "price": 1928.88,
        "softPrice": 2.64,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036PU"
    },
    {
        "name": "ECS-4vCPU-32GB-WIN-1Yr-PartUpFront",
        "price": 860.07,
        "softPrice": 1.18,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0103212PU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-PartUpFront",
        "price": 1282.06,
        "softPrice": 1.76,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612PU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-3Yrs-PartUpFront",
        "price": 1104.16,
        "softPrice": 1.51,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111236PU"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-3Yrs-NoUpFront",
        "price": 1205.88,
        "softPrice": 1.65,
        "vcpu": "14",
        "ram": "56",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105636MO"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-3Yrs-UpFront",
        "price": 998.31,
        "softPrice": 1.37,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204436FU"
    },
    {
        "name": "HANA-16vCPU-128GB-On-Demand",
        "price": 4155.8,
        "softPrice": 4155.8,
        "vcpu": "16",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112800MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-NoUpFront",
        "price": 1493.44,
        "softPrice": 2.05,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012MO"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-UpFront",
        "price": 3875.45,
        "softPrice": 5.31,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212FU"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-PartUpFront",
        "price": 157.74,
        "softPrice": 0.22,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636PU"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-On-Demand",
        "price": 4607.67,
        "softPrice": 4607.67,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109600MO"
    },
    {
        "name": "HANA-32vCPU-256GB-3Yrs-PartUpFront",
        "price": 4046.9,
        "softPrice": 5.54,
        "vcpu": "32",
        "ram": "256",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0125636PU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-3Yrs-NoUpFront",
        "price": 852.92,
        "softPrice": 1.17,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104836MO"
    },
    {
        "name": "Roundcube-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "DNGJAHPX"
    },
    {
        "name": "ECS-14vCPU-112GB-RedHat-3Yrs-NoUpFront",
        "price": 1355.58,
        "softPrice": 1.86,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0111236MO"
    },
    {
        "name": "ECS-22vCPU-44GB-WIN-1Yr-NoUpFront",
        "price": 2043.18,
        "softPrice": 2.8,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204412MO"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-UpFront",
        "price": 554.79,
        "softPrice": 0.76,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436FU"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-UpFront",
        "price": 1240.14,
        "softPrice": 1.7,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836FU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-1Yr-NoUpFront",
        "price": 1344.1,
        "softPrice": 1.84,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203612MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-3Yrs-NoUpFront",
        "price": 1542.01,
        "softPrice": 2.11,
        "vcpu": "18",
        "ram": "144",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114436MO"
    },
    {
        "name": "Nginx-Open-Source-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "LUXIVCPR"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-On-Demand",
        "price": 654.82,
        "softPrice": 654.82,
        "vcpu": "6",
        "ram": "12",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201200MO"
    },
    {
        "name": "ECS-24vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 1521.98,
        "softPrice": 2.08,
        "vcpu": "24",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204836FU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-UpFront",
        "price": 1401.54,
        "softPrice": 1.92,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012FU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-1Yr-NoUpFront",
        "price": 3091.4,
        "softPrice": 4.23,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109612MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 78.87,
        "softPrice": 0.11,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100836PU"
    },
    {
        "name": "HANA-8vCPU-64GB-1Yr-UpFront",
        "price": 1496.6,
        "softPrice": 2.05,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106412FU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 301.58,
        "softPrice": 0.41,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101636PU"
    },
    {
        "name": "HANA-12vCPU-96GB-3Yrs-PartUpFront",
        "price": 1626.9,
        "softPrice": 2.23,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0109636PU"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-1Yr-PartUpFront",
        "price": 1560.2,
        "softPrice": 2.14,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109612PU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-3Yrs-PartUpFront",
        "price": 2018.36,
        "softPrice": 2.76,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109636PU"
    },
    {
        "name": "Oracle-32vCPU-128GB-1Yr-UpFront",
        "price": 6904.22,
        "softPrice": 9.46,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0112812FU"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-PartUpFront",
        "price": 1019.78,
        "softPrice": 1.4,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012PU"
    },
    {
        "name": "HANA-10vCPU-80GB-1Yr-PartUpFront",
        "price": 1911,
        "softPrice": 2.62,
        "vcpu": "10",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108012PU"
    },
    {
        "name": "Oracle-16vCPU-64GB-3Yrs-NoUpFront",
        "price": 3194.98,
        "softPrice": 4.38,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106436MO"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-3Yrs-UpFront",
        "price": 1005.88,
        "softPrice": 1.38,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203236FU"
    },
    {
        "name": "Oracle-8vCPU-64GB-1Yr-UpFront",
        "price": 2085.97,
        "softPrice": 2.86,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0106412FU"
    },
    {
        "name": "ECS-1vCPU-2GB-WIN-1Yr-PartUpFront",
        "price": 88.59,
        "softPrice": 0.12,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200212PU"
    },
    {
        "name": "ECS-4vCPU-32GB-Linux-1Yr-UpFront",
        "price": 446.01,
        "softPrice": 0.61,
        "vcpu": "4",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0103212FU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-PartUpFront",
        "price": 988.64,
        "softPrice": 1.35,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836PU"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-On-Demand",
        "price": 2588.88,
        "softPrice": 2588.88,
        "vcpu": "18",
        "ram": "72",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107200MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-1Yr-PartUpFront",
        "price": 225.73,
        "softPrice": 0.31,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101612PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-UpFront",
        "price": 620.07,
        "softPrice": 0.85,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436FU"
    },
    {
        "name": "Oracle-12vCPU-96GB-1Yr-NoUpFront",
        "price": 3327.07,
        "softPrice": 4.56,
        "vcpu": "12",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0109612MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-1Yr-UpFront",
        "price": 1003.33,
        "softPrice": 1.37,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202012FU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-NoUpFront",
        "price": 2971.9,
        "softPrice": 4.07,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-UpFront",
        "price": 2014.37,
        "softPrice": 2.76,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436FU"
    },
    {
        "name": "ECS-10vCPU-20GB-Linux-1Yr-UpFront",
        "price": 700.77,
        "softPrice": 0.96,
        "vcpu": "10",
        "ram": "20",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202012FU"
    },
    {
        "name": "ECS-8vCPU-16GB-WIN-1Yr-UpFront",
        "price": 697.25,
        "softPrice": 0.96,
        "vcpu": "8",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201612FU"
    },
    {
        "name": "Drupal-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "IYHZXKHH"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-3Yrs-PartUpFront",
        "price": 976.48,
        "softPrice": 1.34,
        "vcpu": "20",
        "ram": "40",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204036PU"
    },
    {
        "name": "ECS-26vCPU-104GB-WIN-3YrsNoUpFront",
        "price": 2902.12,
        "softPrice": 3.98,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0110436MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-3Yrs-NoUpFront",
        "price": 2740.26,
        "softPrice": 3.75,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112836MO"
    },
    {
        "name": "Oracle-64vCPU-512GB-1Yr-PartUpFront",
        "price": 15816.08,
        "softPrice": 21.67,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151212PU"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-On-Demand",
        "price": 2182.72,
        "softPrice": 2182.72,
        "vcpu": "20",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204000MO"
    },
    {
        "name": "ECS-6vCPU-24GB-Linux-1Yr-NoUpFront",
        "price": 607.08,
        "softPrice": 0.83,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0102412MO"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-3Yrs-PartUpFront",
        "price": 3464.68,
        "softPrice": 4.75,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112836PU"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-3Yrs-PartUpFront",
        "price": 433.09,
        "softPrice": 0.59,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101636PU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-On-Demand",
        "price": 4837.9,
        "softPrice": 4837.9,
        "vcpu": "18",
        "ram": "144",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114400MO"
    },
    {
        "name": "Oracle-14vCPU-112GB-1Yr-NoUpFront",
        "price": 3837.83,
        "softPrice": 5.26,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0111212MO"
    },
    {
        "name": "Oracle-10vCPU-80GB-3Yrs-UpFront",
        "price": 2011.65,
        "softPrice": 2.76,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108036FU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-1Yr-UpFront",
        "price": 1394.51,
        "softPrice": 1.91,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203212FU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3Yrs-UpFront",
        "price": 181.51,
        "softPrice": 0.25,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836FU"
    },
    {
        "name": "ECS-4vCPU-8GB-Linux-3Yrs-PartUpFront",
        "price": 195.3,
        "softPrice": 0.27,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200836PU"
    },
    {
        "name": "ECS-14vCPU-112GB-Linux-1Yr-UpFront",
        "price": 1561.05,
        "softPrice": 2.14,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0111212FU"
    },
    {
        "name": "ECS-18vCPU-36GB-RedHat-1Yr-PartUpFront",
        "price": 1961.58,
        "softPrice": 2.69,
        "vcpu": "18",
        "ram": "36",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203612PU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-1Yr-PartUpFront",
        "price": 2834.74,
        "softPrice": 3.88,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206412PU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-On-Demand",
        "price": 4223.7,
        "softPrice": 4223.7,
        "vcpu": "22",
        "ram": "88",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108800MO"
    },
    {
        "name": "ECS-6vCPU-48GB-Linux-3Yrs-UpFront",
        "price": 465.05,
        "softPrice": 0.64,
        "vcpu": "6",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0104836FU"
    },
    {
        "name": "ECS-14vCPU-28GB-WIN-1Yr-PartUpFront",
        "price": 1240.2,
        "softPrice": 1.7,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0202812PU"
    },
    {
        "name": "ECS-32vCPU-128GB-WIN-On-Demand",
        "price": 6143.56,
        "softPrice": 6143.56,
        "vcpu": "32",
        "ram": "128",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112800MO"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-PartUpFront",
        "price": 3515.09,
        "softPrice": 4.82,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012PU"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-3Yrs-PartUpFront",
        "price": 1299.26,
        "softPrice": 1.78,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104836PU"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-PartUpFront",
        "price": 1290.11,
        "softPrice": 1.77,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812PU"
    },
    {
        "name": "Redis-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "TVPUHMOR"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-1Yr-NoUpFront",
        "price": 3482.54,
        "softPrice": 4.77,
        "vcpu": "24",
        "ram": "96",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109612MO"
    },
    {
        "name": "ECS-20vCPU-80GB-Linux-On-Demand",
        "price": 2876.53,
        "softPrice": 2876.53,
        "vcpu": "20",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0108000MO"
    },
    {
        "name": "ECS-2vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 171.33,
        "softPrice": 0.23,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0101636MO"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-3Yrs-NoUpFront",
        "price": 2455.96,
        "softPrice": 3.36,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111236MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-On-Demand",
        "price": 1577.17,
        "softPrice": 1577.17,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103200MO"
    },
    {
        "name": "Oracle-10vCPU-80GB-On-Demand",
        "price": 3218.64,
        "softPrice": 3218.64,
        "vcpu": "10",
        "ram": "80",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0108000MO"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-3Yrs-NoUpFront",
        "price": 2822.11,
        "softPrice": 3.87,
        "vcpu": "14",
        "ram": "112",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111236MO"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-On-Demand",
        "price": 1780.83,
        "softPrice": 1780.83,
        "vcpu": "12",
        "ram": "24",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202400MO"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-3Yrs-NoUpFront",
        "price": 2313.8,
        "softPrice": 3.17,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110436MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-3Yrs-NoUpFront",
        "price": 1330.93,
        "softPrice": 1.82,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102436MO"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-On-Demand",
        "price": 1864.82,
        "softPrice": 1864.82,
        "vcpu": "10",
        "ram": "40",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104000MO"
    },
    {
        "name": "ECS-24vCPU-96GB-WIN-3Yrs-UpFront",
        "price": 2544.94,
        "softPrice": 3.49,
        "vcpu": "24",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0109636FU"
    },
    {
        "name": "ECS-24vCPU-96GB-Linux-On-Demand",
        "price": 3451.83,
        "softPrice": 3451.83,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0109600MO"
    },
    {
        "name": "ECS-1vCPU-2GB-RedHat-On-Demand",
        "price": 580.34,
        "softPrice": 580.34,
        "vcpu": "1",
        "ram": "2",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200200MO"
    },
    {
        "name": "ECS-10vCPU-20GB-RedHat-3Yrs-NoUpFront",
        "price": 756.61,
        "softPrice": 1.04,
        "vcpu": "10",
        "ram": "20",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202036MO"
    },
    {
        "name": "HANA-10vCPU-80GB-3Yrs-UpFront",
        "price": 1274,
        "softPrice": 1.75,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0108036FU"
    },
    {
        "name": "Oracle-64vCPU-512GB-On-Demand",
        "price": 18979.3,
        "softPrice": 18979.3,
        "vcpu": "64",
        "ram": "512",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0151200MO"
    },
    {
        "name": "ECS-32vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 2389.5,
        "softPrice": 3.27,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206412MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-NoUpFront",
        "price": 2952.56,
        "softPrice": 4.04,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012MO"
    },
    {
        "name": "ECS-32vCPU-128GB-RedHat-1Yr-PartUpFront",
        "price": 3707.42,
        "softPrice": 5.08,
        "vcpu": "32",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112812PU"
    },
    {
        "name": "ECS-14vCPU-112GB-WIN-1Yr-NoUpFront",
        "price": 3090.88,
        "softPrice": 4.23,
        "vcpu": "14",
        "ram": "112",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0111212MO"
    },
    {
        "name": "HANA-40vCPU-160GB-1Yr-UpFront",
        "price": 4954.6,
        "softPrice": 6.79,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116012FU"
    },
    {
        "name": "ECS-20vCPU-80GB-WIN-1Yr-PartUpFront",
        "price": 2835.15,
        "softPrice": 3.88,
        "vcpu": "20",
        "ram": "80",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108012PU"
    },
    {
        "name": "HANA-8vCPU-64GB-1Yr-PartUpFront",
        "price": 1603.5,
        "softPrice": 2.2,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106412PU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-1Yr-PartUpFront",
        "price": 3969.21,
        "softPrice": 5.44,
        "vcpu": "28",
        "ram": "112",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111212PU"
    },
    {
        "name": "ECS-30vCPU-120GB-WIN-On-Demand",
        "price": 5759.59,
        "softPrice": 5759.59,
        "vcpu": "30",
        "ram": "120",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0112000MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 991.98,
        "softPrice": 1.36,
        "vcpu": "16",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203236PU"
    },
    {
        "name": "ECS-28vCPU-112GB-WIN-3Yrs-UpFront",
        "price": 2969.09,
        "softPrice": 4.07,
        "vcpu": "28",
        "ram": "112",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0111236FU"
    },
    {
        "name": "Oracle-12vCPU-48GB-3Yrs-UpFront",
        "price": 2161.2,
        "softPrice": 2.96,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104836FU"
    },
    {
        "name": "Premium-Backup-Service-SW-Only-GB",
        "price": 0.57,
        "softPrice": 0,
        "SKU": "CLBUSPRECVL00000MO"
    },
    {
        "name": "ECS-12vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 1741.27,
        "softPrice": 2.39,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104812MO"
    },
    {
        "name": "Oracle-32vCPU-256GB-On-Demand",
        "price": 9639.65,
        "softPrice": 9639.65,
        "vcpu": "32",
        "ram": "256",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0125600MO"
    },
    {
        "name": "Oracle-4vCPU-16GB-1Yr-PartUpFront",
        "price": 1127.2,
        "softPrice": 1.54,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101612PU"
    },
    {
        "name": "ECS-26vCPU-52GB-WIN-1Yr-PartUpFront",
        "price": 2303.23,
        "softPrice": 3.16,
        "vcpu": "26",
        "ram": "52",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0205212PU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-UpFront",
        "price": 2809.63,
        "softPrice": 3.85,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012FU"
    },
    {
        "name": "Oracle-4vCPU-16GB-3Yrs-UpFront",
        "price": 845.4,
        "softPrice": 1.16,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101636FU"
    },
    {
        "name": "ECS-4vCPU-32GB-RedHat-On-Demand",
        "price": 1108.69,
        "softPrice": 1108.69,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0103200MO"
    },
    {
        "name": "Oracle-4vCPU-16GB-1Yr-UpFront",
        "price": 1070.84,
        "softPrice": 1.47,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0101612FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-1Yr-PartUpFront",
        "price": 862.18,
        "softPrice": 1.18,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102412PU"
    },
    {
        "name": "Oracle-64vCPU-256GB-3Yrs-PartUpFront",
        "price": 11428.16,
        "softPrice": 15.66,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125636PU"
    },
    {
        "name": "AVI-LbaaS-4vCPU-16GB",
        "price": 439,
        "softPrice": 6428.57,
        "SKU": "CLLICVMWLBN00L00MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-1Yr-UpFront",
        "price": 2614.7,
        "softPrice": 3.58,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206012FU"
    },
    {
        "name": "Oracle-2vCPU-8GB-1Yr-UpFront",
        "price": 654.17,
        "softPrice": 0.9,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100812FU"
    },
    {
        "name": "Hadoop-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "YTOEUOSX"
    },
    {
        "name": "ECS-6vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 883.02,
        "softPrice": 1.21,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0104812PU"
    },
    {
        "name": "HANA-64vCPU-256GB-1Yr-PartUpFront",
        "price": 8134.5,
        "softPrice": 11.14,
        "vcpu": "64",
        "ram": "256",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0125612PU"
    },
    {
        "name": "Oracle-2vCPU-8GB-3Yrs-UpFront",
        "price": 516.45,
        "softPrice": 0.71,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100836FU"
    },
    {
        "name": "Oracle-10vCPU-40GB-1Yr-PartUpFront",
        "price": 2443,
        "softPrice": 3.35,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0104012PU"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-NoUpFront",
        "price": 1517.15,
        "softPrice": 2.08,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212MO"
    },
    {
        "name": "ECS-24vCPU-48GB-WIN-1Yr-NoUpFront",
        "price": 2228.93,
        "softPrice": 3.05,
        "vcpu": "24",
        "ram": "48",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0204812MO"
    },
    {
        "name": "Oracle-6vCPU-48GB-1Yr-UpFront",
        "price": 1623.85,
        "softPrice": 2.22,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0104812FU"
    },
    {
        "name": "ECS-6vCPU-24GB-RedHat-3Yrs-NoUpFront",
        "price": 637.26,
        "softPrice": 0.87,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0102436MO"
    },
    {
        "name": "ECS-14vCPU-28GB-RedHat-1Yr-PartUpFront",
        "price": 1304.68,
        "softPrice": 1.79,
        "vcpu": "14",
        "ram": "28",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202812PU"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-3Yrs-UpFront",
        "price": 926.07,
        "softPrice": 1.27,
        "vcpu": "12",
        "ram": "48",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104836FU"
    },
    {
        "name": "ECS-16vCPU-128GB-RedHat-1Yr-PartUpFront",
        "price": 2011.65,
        "softPrice": 2.76,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0112812PU"
    },
    {
        "name": "ECS-18vCPU-72GB-RedHat-1Yr-NoUpFront",
        "price": 2484.32,
        "softPrice": 3.4,
        "vcpu": "18",
        "ram": "72",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0107212MO"
    },
    {
        "name": "Oracle-64vCPU-256GB-3Yrs-UpFront",
        "price": 10713.9,
        "softPrice": 14.68,
        "vcpu": "64",
        "ram": "256",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0125636FU"
    },
    {
        "name": "Exchange-aaS-75GB",
        "price": 56,
        "softPrice": 0,
        "SKU": "CLSASEMLEXC75G00MO"
    },
    {
        "name": "MS-SharePoint-Server-Ent",
        "price": 13.07,
        "softPrice": 0,
        "SKU": "CLLICMS0SHPENT00MO"
    },
    {
        "name": "ECS-12vCPU-96GB-WIN-3Yrs-PartUpFront",
        "price": 2372.87,
        "softPrice": 3.25,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0109636PU"
    },
    {
        "name": "ECS-4vCPU-8GB-WIN-On-Demand",
        "price": 542.94,
        "softPrice": 542.94,
        "vcpu": "4",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200800MO"
    },
    {
        "name": "ECS-14vCPU-56GB-RedHat-On-Demand",
        "price": 2440.13,
        "softPrice": 2440.13,
        "vcpu": "14",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0105600MO"
    },
    {
        "name": "ECS-20vCPU-40GB-Linux-1Yr-PartUpFront",
        "price": 1424.51,
        "softPrice": 1.95,
        "vcpu": "20",
        "ram": "40",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204012PU"
    },
    {
        "name": "ECS-30vCPU-60GB-Linux-1Yr-UpFront",
        "price": 2102.3,
        "softPrice": 2.88,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0206012FU"
    },
    {
        "name": "ECS-28vCPU-112GB-RedHat-On-Demand",
        "price": 4969.7,
        "softPrice": 4969.7,
        "vcpu": "28",
        "ram": "112",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0111200MO"
    },
    {
        "name": "MS-Exchange-Server-Bas",
        "price": 3.38,
        "softPrice": 0,
        "SKU": "CLLICMS0EXCBAS00MO"
    },
    {
        "name": "ECS-4vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 567.03,
        "softPrice": 0.78,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0101612PU"
    },
    {
        "name": "Egress-Outbound-Traffic",
        "price": 1.84,
        "softPrice": 0,
        "SKU": "CL0NWEGR00000000MO"
    },
    {
        "name": "ECS-6vCPU-12GB-WIN-3Yrs-PartUpFront",
        "price": 385.78,
        "softPrice": 0.53,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0201236PU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-On-Demand",
        "price": 2400.99,
        "softPrice": 2400.99,
        "vcpu": "22",
        "ram": "44",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204400MO"
    },
    {
        "name": "ECS-16vCPU-32GB-RedHat-1Yr-PartUpFront",
        "price": 1447.13,
        "softPrice": 1.98,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0203212PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-1Yr-NoUpFront",
        "price": 74.67,
        "softPrice": 0.1,
        "vcpu": "1",
        "ram": "2",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200212MO"
    },
    {
        "name": "Elastic-Volume-Service-SSD-GB",
        "price": 0.46,
        "softPrice": 0,
        "SKU": "CLSTOEVSSSD00000MO"
    },
    {
        "name": "Oracle-8vCPU-32GB-On-Demand",
        "price": 2405.28,
        "softPrice": 2405.28,
        "vcpu": "8",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0103200MO"
    },
    {
        "name": "Oracle-2vCPU-8GB-On-Demand",
        "price": 826.32,
        "softPrice": 826.32,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100800MO"
    },
    {
        "name": "ECS-2vCPU-4GB-WIN-3Yrs-PartUpFront",
        "price": 128.59,
        "softPrice": 0.18,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0200436PU"
    },
    {
        "name": "HANA-16vCPU-128GB-3Yrs-UpFront",
        "price": 1889,
        "softPrice": 2.59,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0112836FU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-NoUpFront",
        "price": 101.18,
        "softPrice": 0.14,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412MO"
    },
    {
        "name": "ECS-30vCPU-60GB-RedHat-1Yr-UpFront",
        "price": 2770.86,
        "softPrice": 3.8,
        "vcpu": "30",
        "ram": "60",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206012FU"
    },
    {
        "name": "ECS-2vCPU-8GB-WIN-On-Demand",
        "price": 383.97,
        "softPrice": 383.97,
        "vcpu": "2",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0100800MO"
    },
    {
        "name": "ECS-12vCPU-96GB-Linux-3Yrs-UpFront",
        "price": 930.1,
        "softPrice": 1.27,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0109636FU"
    },
    {
        "name": "ECS-4vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 247.52,
        "softPrice": 0.34,
        "vcpu": "4",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0101636FU"
    },
    {
        "name": "ECS-18vCPU-36GB-Linux-3Yrs-PartUpFront",
        "price": 878.83,
        "softPrice": 1.2,
        "vcpu": "18",
        "ram": "36",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203636PU"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-1Yr-PartUpFront",
        "price": 592.42,
        "softPrice": 0.81,
        "vcpu": "4",
        "ram": "8",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200812PU"
    },
    {
        "name": "ECS-16vCPU-128GB-WIN-1Yr-NoUpFront",
        "price": 3532.43,
        "softPrice": 4.84,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0112812MO"
    },
    {
        "name": "HANA-8vCPU-64GB-1Yr-NoUpFront",
        "price": 1710.4,
        "softPrice": 2.34,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0106412MO"
    },
    {
        "name": "ECS-4vCPU-8GB-RedHat-3Yrs-NoUpFront",
        "price": 439.54,
        "softPrice": 0.6,
        "vcpu": "4",
        "ram": "8",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200836MO"
    },
    {
        "name": "ECS-4vCPU-16GB-RedHat-1Yr-NoUpFront",
        "price": 704.8,
        "softPrice": 0.97,
        "vcpu": "4",
        "ram": "16",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0101612MO"
    },
    {
        "name": "ECS-1vCPU-8GB-RedHat-3Yrs-UpFront",
        "price": 218.87,
        "softPrice": 0.3,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0100836FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-PartUpFront",
        "price": 902.91,
        "softPrice": 1.24,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-On-Demand",
        "price": 727.94,
        "softPrice": 727.94,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101600MO"
    },
    {
        "name": "Oracle-16vCPU-128GB-1Yr-UpFront",
        "price": 3934.44,
        "softPrice": 5.39,
        "vcpu": "16",
        "ram": "128",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0112812FU"
    },
    {
        "name": "ECS-18vCPU-144GB-WIN-1Yr-PartUpFront",
        "price": 3870.32,
        "softPrice": 5.3,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0114412PU"
    },
    {
        "name": "FwaaS-FortiNet-Advanced-Small",
        "price": 74.67,
        "softPrice": 775.66,
        "SKU": "CLLICFORFWA00S12MO"
    },
    {
        "name": "ECS-6vCPU-12GB-Linux-3Yrs-UpFront",
        "price": 272.27,
        "softPrice": 0.37,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201236FU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-UpFront",
        "price": 1384.09,
        "softPrice": 1.9,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012FU"
    },
    {
        "name": "ECS-12vCPU-48GB-Linux-1Yr-PartUpFront",
        "price": 1153.96,
        "softPrice": 1.58,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104812PU"
    },
    {
        "name": "ECS-1vCPU-4GB-Linux-1Yr-PartUpFront",
        "price": 96.16,
        "softPrice": 0.13,
        "vcpu": "1",
        "ram": "4",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0100412PU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-3Yrs-NoUpFront",
        "price": 403.16,
        "softPrice": 0.55,
        "vcpu": "2",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101636MO"
    },
    {
        "name": "MS-Hosted-Exchange-SAL-for-SA-Std",
        "price": 1.5,
        "softPrice": 0,
        "SKU": "CLMOBMS0EXCSTD00MO"
    },
    {
        "name": "ECS-18vCPU-144GB-Linux-1Yr-UpFront",
        "price": 2007.06,
        "softPrice": 2.75,
        "vcpu": "18",
        "ram": "144",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0114412FU"
    },
    {
        "name": "Oracle-4vCPU-32GB-3Yrs-UpFront",
        "price": 917.16,
        "softPrice": 1.26,
        "vcpu": "4",
        "ram": "32",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103236FU"
    },
    {
        "name": "Oracle-16vCPU-64GB-1Yr-PartUpFront",
        "price": 3758.8,
        "softPrice": 5.15,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106412PU"
    },
    {
        "name": "Odoo-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "OTGVPLKC"
    },
    {
        "name": "FwaaS-FortiNet-Basic-Large",
        "price": 298.69,
        "softPrice": 1400.73,
        "SKU": "CLLICFORFWB00L12MO"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-1Yr-NoUpFront",
        "price": 2803.22,
        "softPrice": 3.84,
        "vcpu": "28",
        "ram": "56",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205612MO"
    },
    {
        "name": "ECS-16vCPU-128GB-Linux-3Yrs-NoUpFront",
        "price": 1370.68,
        "softPrice": 1.88,
        "vcpu": "16",
        "ram": "128",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0112836MO"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-PartUpFront",
        "price": 431.57,
        "softPrice": 0.59,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612PU"
    },
    {
        "name": "HANA-40vCPU-160GB-1Yr-PartUpFront",
        "price": 5308.5,
        "softPrice": 7.27,
        "vcpu": "40",
        "ram": "160",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "HANA",
        "SKU": "CLHAN000G0116012PU"
    },
    {
        "name": "ECS-16vCPU-32GB-WIN-On-Demand",
        "price": 2171.78,
        "softPrice": 2171.78,
        "vcpu": "16",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0203200MO"
    },
    {
        "name": "ECS-14vCPU-56GB-Linux-1Yr-UpFront",
        "price": 1311.16,
        "softPrice": 1.8,
        "vcpu": "14",
        "ram": "56",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0105612FU"
    },
    {
        "name": "ECS-1vCPU-8GB-WIN-3Yrs-PartUpFront",
        "price": 197.74,
        "softPrice": 0.27,
        "vcpu": "1",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0100836PU"
    },
    {
        "name": "ECS-1vCPU-2GB-Linux-3Yrs-UpFront",
        "price": 45.38,
        "softPrice": 0.06,
        "vcpu": "1",
        "ram": "2",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0200236FU"
    },
    {
        "name": "ECS-24vCPU-96GB-RedHat-On-Demand",
        "price": 4394.39,
        "softPrice": 4394.39,
        "vcpu": "24",
        "ram": "96",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0109600MO"
    },
    {
        "name": "ECS-10vCPU-40GB-Linux-3Yrs-NoUpFront",
        "price": 710.77,
        "softPrice": 0.97,
        "vcpu": "10",
        "ram": "40",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0104036MO"
    },
    {
        "name": "ECS-6vCPU-12GB-RedHat-3Yrs-UpFront",
        "price": 468.19,
        "softPrice": 0.64,
        "vcpu": "6",
        "ram": "12",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201236FU"
    },
    {
        "name": "Oracle-4vCPU-32GB-On-Demand",
        "price": 1467.46,
        "softPrice": 1467.46,
        "vcpu": "4",
        "ram": "32",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Oracle",
        "SKU": "CLORC000M0103200MO"
    },
    {
        "name": "Trac-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "PILVPFGD"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-1Yr-PartUpFront",
        "price": 2884.89,
        "softPrice": 3.95,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112012PU"
    },
    {
        "name": "ECS-2vCPU-8GB-RedHat-3Yrs-PartUpFront",
        "price": 328.04,
        "softPrice": 0.45,
        "vcpu": "2",
        "ram": "8",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0100836PU"
    },
    {
        "name": "Oracle-2vCPU-8GB-1Yr-NoUpFront",
        "price": 723.03,
        "softPrice": 0.99,
        "vcpu": "2",
        "ram": "8",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0100812MO"
    },
    {
        "name": "Object-Storage-Service-Standard-GB",
        "price": 0.07,
        "softPrice": 0,
        "SKU": "CLSTOOSSSTN00000MO"
    },
    {
        "name": "Oracle-16vCPU-64GB-On-Demand",
        "price": 4510.56,
        "softPrice": 4510.56,
        "vcpu": "16",
        "ram": "64",
        "com": "OD",
        "mod": "MO",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106400MO"
    },
    {
        "name": "ECS-12vCPU-96GB-RedHat-3Yrs-UpFront",
        "price": 1071.46,
        "softPrice": 1.47,
        "vcpu": "12",
        "ram": "96",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0109636FU"
    },
    {
        "name": "ECS-22vCPU-44GB-Linux-1Yr-UpFront",
        "price": 1541.69,
        "softPrice": 2.11,
        "vcpu": "22",
        "ram": "44",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204412FU"
    },
    {
        "name": "ECS-32vCPU-64GB-RedHat-1Yr-UpFront",
        "price": 2911.02,
        "softPrice": 3.99,
        "vcpu": "32",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0206412FU"
    },
    {
        "name": "MS-SQL-Std-Cluster",
        "price": 450,
        "softPrice": 0,
        "SKU": "CLMCSDTBSQLSTC00MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-UpFront",
        "price": 363.02,
        "softPrice": 0.5,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636FU"
    },
    {
        "name": "ECS-8vCPU-32GB-Linux-1Yr-UpFront",
        "price": 749.24,
        "softPrice": 1.03,
        "vcpu": "8",
        "ram": "32",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0103212FU"
    },
    {
        "name": "ECS-32vCPU-128GB-Linux-3Yrs-UpFront",
        "price": 1980.12,
        "softPrice": 2.71,
        "vcpu": "32",
        "ram": "128",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112836FU"
    },
    {
        "name": "ECS-26vCPU-104GB-Linux-3Yrs-UpFront",
        "price": 1608.85,
        "softPrice": 2.2,
        "vcpu": "26",
        "ram": "104",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0110436FU"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-1Yr-NoUpFront",
        "price": 3698.49,
        "softPrice": 5.07,
        "vcpu": "30",
        "ram": "120",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112012MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-3YrsNoUpFront",
        "price": 1785.92,
        "softPrice": 2.45,
        "vcpu": "16",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106436MO"
    },
    {
        "name": "HANA-64vCPU-512GB-3Yrs-UpFront",
        "price": 6959,
        "softPrice": 9.53,
        "vcpu": "64",
        "ram": "512",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151236FU"
    },
    {
        "name": "ECS-28vCPU-56GB-RedHat-On-Demand",
        "price": 4097.01,
        "softPrice": 4097.01,
        "vcpu": "28",
        "ram": "56",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205600MO"
    },
    {
        "name": "ECS-16vCPU-64GB-Linux-1Yr-NoUpFront",
        "price": 1618.88,
        "softPrice": 2.22,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0106412MO"
    },
    {
        "name": "ECS-16vCPU-32GB-Linux-1Yr-NoUpFront",
        "price": 1194.75,
        "softPrice": 1.64,
        "vcpu": "16",
        "ram": "32",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0203212MO"
    },
    {
        "name": "ECS-10vCPU-80GB-RedHat-3Yrs-UpFront",
        "price": 916.45,
        "softPrice": 1.26,
        "vcpu": "10",
        "ram": "80",
        "mod": "3Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0108036FU"
    },
    {
        "name": "HANA-64vCPU-512GB-On-Demand",
        "price": 15309.8,
        "softPrice": 15309.8,
        "vcpu": "64",
        "ram": "512",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151200MO"
    },
    {
        "name": "HANA-64vCPU-512GB-1Yr-UpFront",
        "price": 9742.6,
        "softPrice": 13.35,
        "vcpu": "64",
        "ram": "512",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "HANA",
        "SKU": "CLHAN000M0151212FU"
    },
    {
        "name": "ECS-22vCPU-44GB-RedHat-3Yrs-UpFront",
        "price": 1431.23,
        "softPrice": 1.96,
        "vcpu": "22",
        "ram": "44",
        "mod": "3Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0204436FU"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-On-Demand",
        "price": 537.54,
        "softPrice": 537.54,
        "vcpu": "2",
        "ram": "16",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101600MO"
    },
    {
        "name": "ECS-6vCPU-48GB-WIN-1Yr-UpFront",
        "price": 1255.55,
        "softPrice": 1.72,
        "vcpu": "6",
        "ram": "48",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0104812FU"
    },
    {
        "name": "Managed-Network",
        "price": 250,
        "softPrice": 0,
        "SKU": "CLMCSNETSWI00000MO"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-3Yrs-NoUpFront",
        "price": 1971.74,
        "softPrice": 2.7,
        "vcpu": "30",
        "ram": "60",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206036MO"
    },
    {
        "name": "ECS-1vCPU-8GB-Linux-On-Demand",
        "price": 190.37,
        "softPrice": 190.37,
        "vcpu": "1",
        "ram": "8",
        "com": "OD",
        "mod": "MO",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0100800MO"
    },
    {
        "name": "ECS-8vCPU-16GB-Linux-3Yrs-NoUpFront",
        "price": 422.76,
        "softPrice": 0.58,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0201636MO"
    },
    {
        "name": "ECS-8vCPU-32GB-RedHat-3Yrs-PartUpFront",
        "price": 724.4,
        "softPrice": 0.99,
        "vcpu": "8",
        "ram": "32",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0103236PU"
    },
    {
        "name": "ECS-10vCPU-40GB-WIN-1Yr-NoUpFront",
        "price": 1451.06,
        "softPrice": 1.99,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0104012MO"
    },
    {
        "name": "ECS-6vCPU-24GB-WIN-3Yrs-UpFront",
        "price": 636.23,
        "softPrice": 0.87,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0102436FU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-PartUpFront",
        "price": 1162.23,
        "softPrice": 1.59,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412PU"
    },
    {
        "name": "ECS-26vCPU-104GB-RedHat-1Yr-NoUpFront",
        "price": 3293.77,
        "softPrice": 4.51,
        "vcpu": "26",
        "ram": "104",
        "mod": "1Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0110412MO"
    },
    {
        "name": "ECS-12vCPU-48GB-RedHat-1Yr-PartUpFront",
        "price": 1439.16,
        "softPrice": 1.97,
        "vcpu": "12",
        "ram": "48",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104812PU"
    },
    {
        "name": "Oracle-40vCPU-160GB-3Yrs-PartUpFront",
        "price": 7217.6,
        "softPrice": 9.89,
        "vcpu": "40",
        "ram": "160",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0116036PU"
    },
    {
        "name": "ECS-12vCPU-24GB-Linux-1Yr-UpFront",
        "price": 840.92,
        "softPrice": 1.15,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "FU",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0202412FU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-1Yr-UpFront",
        "price": 892.03,
        "softPrice": 1.22,
        "vcpu": "8",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106412FU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-1Yr-UpFront",
        "price": 3044.99,
        "softPrice": 4.17,
        "vcpu": "22",
        "ram": "88",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108812FU"
    },
    {
        "name": "Oracle-16vCPU-64GB-1Yr-UpFront",
        "price": 3570.86,
        "softPrice": 4.89,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0106412FU"
    },
    {
        "name": "ECS-30vCPU-120GB-RedHat-3Yrs-UpFront",
        "price": 2261.88,
        "softPrice": 3.1,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0112036FU"
    },
    {
        "name": "Exchange-aaS-20GB",
        "price": 41,
        "softPrice": 0,
        "SKU": "CLSASEMLEXC20G00MO"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-1Yr-NoUpFront",
        "price": 1218.46,
        "softPrice": 1.67,
        "vcpu": "12",
        "ram": "24",
        "mod": "1Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202412MO"
    },
    {
        "name": "Oracle-6vCPU-24GB-1Yr-PartUpFront",
        "price": 1565.8,
        "softPrice": 2.14,
        "vcpu": "6",
        "ram": "24",
        "mod": "1Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102412PU"
    },
    {
        "name": "ECS-12vCPU-24GB-RedHat-3Yrs-PartUpFront",
        "price": 796.69,
        "softPrice": 1.09,
        "vcpu": "12",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0202436PU"
    },
    {
        "name": "ECS-26vCPU-52GB-RedHat-3Yrs-PartUpFront",
        "price": 1735.22,
        "softPrice": 2.38,
        "vcpu": "26",
        "ram": "52",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0205236PU"
    },
    {
        "name": "ECS-8vCPU-64GB-Linux-3Yrs-NoUpFront",
        "price": 685.34,
        "softPrice": 0.94,
        "vcpu": "8",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "M01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXM0106436MO"
    },
    {
        "name": "ECS-2vCPU-4GB-RedHat-3Yrs-PartUpFront",
        "price": 308.45,
        "softPrice": 0.42,
        "vcpu": "2",
        "ram": "4",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0200436PU"
    },
    {
        "name": "Managed-ADC-LB",
        "price": 250,
        "softPrice": 0,
        "SKU": "CLMCSNETADC00000MO"
    },
    {
        "name": "ECS-2vCPU-16GB-WIN-1Yr-PartUpFront",
        "price": 430.04,
        "softPrice": 0.59,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "PU",
        "specs": "M01",
        "os_name": "Windows",
        "SKU": "CLECSWINM0101612PU"
    },
    {
        "name": "ECS-22vCPU-88GB-RedHat-3Yrs-PartUpFront",
        "price": 1886.24,
        "softPrice": 2.58,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0108836PU"
    },
    {
        "name": "ECS-2vCPU-16GB-RedHat-1Yr-UpFront",
        "price": 426.37,
        "softPrice": 0.58,
        "vcpu": "2",
        "ram": "16",
        "mod": "1Y",
        "com": "FU",
        "specs": "M01",
        "os_name": "Redhat",
        "SKU": "CLECSREDM0101612FU"
    },
    {
        "name": "ECS-10vCPU-40GB-RedHat-1Yr-UpFront",
        "price": 1214.3,
        "softPrice": 1.66,
        "vcpu": "10",
        "ram": "40",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0104012FU"
    },
    {
        "name": "ECS-8vCPU-16GB-RedHat-3Yrs-PartUpFront",
        "price": 601.39,
        "softPrice": 0.82,
        "vcpu": "8",
        "ram": "16",
        "mod": "3Y",
        "com": "PU",
        "specs": "G02",
        "os_name": "Redhat",
        "SKU": "CLECSREDG0201636PU"
    },
    {
        "name": "Oracle-6vCPU-24GB-3Yrs-PartUpFront",
        "price": 1252.64,
        "softPrice": 1.72,
        "vcpu": "6",
        "ram": "24",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Oracle",
        "SKU": "CLORC000G0102436PU"
    },
    {
        "name": "ECS-32vCPU-64GB-WIN-3Yrs-NoUpFront",
        "price": 2103.19,
        "softPrice": 2.88,
        "vcpu": "32",
        "ram": "64",
        "mod": "3Y",
        "com": "NU",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206436MO"
    },
    {
        "name": "ECS-24vCPU-48GB-Linux-On-Demand",
        "price": 2619.26,
        "softPrice": 2619.26,
        "vcpu": "24",
        "ram": "48",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0204800MO"
    },
    {
        "name": "ECS-16vCPU-64GB-WIN-1Yr-UpFront",
        "price": 2214.54,
        "softPrice": 3.03,
        "vcpu": "16",
        "ram": "64",
        "mod": "1Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0106412FU"
    },
    {
        "name": "ECS-30vCPU-120GB-Linux-3Yrs-PartUpFront",
        "price": 1981.79,
        "softPrice": 2.71,
        "vcpu": "30",
        "ram": "120",
        "mod": "3Y",
        "com": "PU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0112036PU"
    },
    {
        "name": "ECS-22vCPU-88GB-WIN-3YrsNoUpFront",
        "price": 2455.64,
        "softPrice": 3.36,
        "vcpu": "22",
        "ram": "88",
        "mod": "3Y",
        "com": "NU",
        "specs": "G01",
        "os_name": "Windows",
        "SKU": "CLECSWING0108836MO"
    },
    {
        "name": "MySQL-Certified-by-Bitnami",
        "price": 0,
        "softPrice": 0,
        "SKU": "AACHQYTR"
    },
    {
        "name": "ECS-30vCPU-60GB-WIN-On-Demand",
        "price": 4072.08,
        "softPrice": 4072.08,
        "vcpu": "30",
        "ram": "60",
        "com": "OD",
        "mod": "MO",
        "specs": "G02",
        "os_name": "Windows",
        "SKU": "CLECSWING0206000MO"
    },
    {
        "name": "ECS-18vCPU-72GB-Linux-3Yrs-UpFront",
        "price": 1113.82,
        "softPrice": 1.53,
        "vcpu": "18",
        "ram": "72",
        "mod": "3Y",
        "com": "FU",
        "specs": "G01",
        "os_name": "Free Linux",
        "SKU": "CLECSLNXG0107236FU"
    }
]
pricingData.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));

export default pricingData;